<!-- Shop Evaluation -->
<template>
  <div class="se-list-page">
    <div class="left-section" :class="{ expanded: isExpanded }">
      <div class="left-section-top">
        <table class="header-table">
          <tbody>
            <tr>
              <th>총고객수</th>
              <td>
                {{ totalCustomers ? totalCustomers.toLocaleString() : "0" }}
              </td>
              <th>가용</th>
              <td class="avaiCus">
                {{
                  availableCustomers ? availableCustomers.toLocaleString() : "0"
                }}
              </td>
              <!-- <th>점포명</th>
            <td>{{ selectedShop ? selectedShop.SHOP_NM : "" }}</td> -->
            </tr>
          </tbody>
        </table>
        <input
          type="button"
          value="사업소득 1억 이상 벌어 성공하자"
          style="
            width: 45%;
            height: auto;
            margin: 0px;
            font-size: 1rem;
            background-color: #99baf0;
            border: 1px;
          "
        />
        <!-- <input
          type="button"
          :value="`${selectedShop?.SHOP_NM || ''} 위탁 운영 현황표`"
          style="
            width: 45%;
            height: auto;
            margin: 0px;
            font-size: 1.4rem;
            background-color: #ff0000;
            border: 1px;
            color: #ffffff;
            font-weight: bold;
          "
        /> -->
      </div>
      <div class="expandable-content">
        <ag-grid-vue
          class="ag-se-balham"
          :theme="theme"
          :style="{ width: '100%', height: gridHeight2 + 'rem' }"
          :rowData="rowData2"
          :columnDefs="columnDefs2"
          :gridOptions="gridOptions2"
          @grid-ready="onLeftGridReady"
          :rowHeight="rowHeight"
          @cell-value-changed="onCellValueChanged"
          :enableCellSpan="true"
        ></ag-grid-vue>
      </div>
       <!-- 사업주 성공목적 및 의견 입력 섹션 -->
      <div class="shop-comment-section" v-if="this.useNewSeListGrid">
        <!-- <div class="comment-row">
          <div class="comment-index">32</div>
          <label>사업 이유와 목적</label>
          <input type="text" v-model="ownerGoal" placeholder="사업 이유와 목적을 입력하세요" />
          <button @click="checkAndSave('OWNER_GOAL', ownerGoal, 'OGN_FG', '01')" class="btn-save-comments">저장</button>
        </div>
        <div class="comment-row">
          <div class="comment-index">33</div>
          <label>사업주 성공방법</label>
          <input type="text" v-model="ownerHow" placeholder="사업주 성공방법을 입력하세요" />
          <button @click="checkAndSave('OWNER_HOW', ownerHow, 'OGN_FG', '01')" class="btn-save-comments">저장</button>
        </div> -->
        <!-- <div class="comment-row">
          <div class="comment-index">34</div>
          <label>사업주 하면 좋은점</label>
          <input type="text" v-model="opinion1" placeholder="사업주 하면 좋은점" />
          <button @click="checkAndSave('OPINION1', opinion1, 'OGN_FG', '01')" class="btn-save-comments">저장</button>
        </div> -->
        <div class="comment-row">
          <div class="comment-index">35</div>
          <label>사업주</label>
          <!-- <input type="text" value="다수 직원을 고용하여 능력에 따라 무한대로 사업소득을 버는사람"  readonly/> -->
          <!-- <input type="text" value="직원을 고용해 사업능력에 따라 무한대로 사업소득을 벌고, 돈을 벌어 고용한 직원에게 월급을 주는 사업가 입니다."  readonly/> -->
          <!-- <input type="text" value="사업주 본인 이익을 위해 사업주 결정으로 직원을 고용해 사업소득을 벌고 고용한 직원에게 월급 주는 사업가 입니다."  readonly/> --> <!-- 261016수정 -->
           <input type="text" value="보증금 및 브랜드 사용료를 납부하며 사업주 본인 이익을 위해 사업주 결정으로 직원을 고용해 월급 주면서 사업 능력대로 사업소득을 버는 사람"  readonly/>
          <!-- <button @click="checkAndSave('OPINION1', opinion1, 'OGN_FG', '01')" class="btn-save-comments">저장</button> -->
        </div>
        <div class="comment-row">
          <div class="comment-index">36</div>
          <!-- <label>FC 컨설턴트</label> -->
          <!-- <input type="text" v-model="businessMap" placeholder="" /> -->
          <!-- <button @click="checkAndSave('BUSINESS_MAP', businessMap, 'EMP_CLASS_NM', '본부장')" class="btn-save-comments">저장</button> -->
           <label>사업주 모집</label>
          <input type="text" value="1억이상 사업소득을 버는 사업주가 많습니다. 사업주가 되어 많이 벌어 부자 되세요. ※사업주 청약문의) 010-9921-7181"  readonly/>
        </div>
        <div class="comment-row">
          <div class="comment-index">37</div>
          <label>성비수기 흑적자</label>
          <input type="text"  
          value="성수기는 돈을 많이 벌어도 비수기는 적자가 될수 있으므로 비수기를 대비해 사업소득을 비축해 사업에 차질이 없기 바랍니다."
          readonly
          />
          <!-- <label :class="{ blink: warningFlag }">계약수량 이행여부</label>
          <input type="text" :class="{ blink: warningFlag }" 
          value="사업주가 제안하여 계약한 계약수량과 보증금을 이행하지 않는 경우 위수탁 사업계약이 해지 될수있으므로 계약 잘 이행바랍니다."
          readonly
          /> -->
          <!-- :value="warningFlag 
            ? '계약수량 보다 20% 이상 하락중으로 계약해지 될 수 있으므로 분발하시기 바랍니다.' 
            : '사업주가 제안하여 계약한 계약수량과 보증금을 이행하지 않는 경우 위수탁 사업계약이 해지 될수있으므로 계약 잘 이행바랍니다.'" -->
          <!-- <input type="text" v-model="contractConfirm" placeholder="" /> -->
          <!-- <button @click="checkAndSave('CONTRACT_CONFIRM', contractConfirm, 'EMP_CLASS_NM', '본부장')" class="btn-save-comments">저장</button> -->
        </div>
        <div class="comment-row">
          <div class="comment-index">38</div>
          <label>FC 컨설턴트</label>
          <!-- <input type="text" v-model="businessMap" placeholder="" /> -->
          <textarea v-model="businessMap" rows="3" placeholder="내용을 입력하세요"></textarea>
          <button @click="checkAndSave('BUSINESS_MAP', businessMap, 'EMP_CLASS_NM', '본부장')" class="btn-save-comments">저장</button>
        </div>
        <!-- <div class="comment-row" v-if="false">
          <div class="comment-index">35</div>
          <label>의견 입력 2</label>
          <input type="text" v-model="opinion2" placeholder="벤치 마킹 점표" />
          <button @click="checkAndSave('OPINION2', opinion2, 'EMP_CLASS_NM', '본부장')" class="btn-save-comments">저장</button>
        </div> -->
      </div>
      <!-- 펼치기/접기 테이블 -->
       <!-- v-if="false" 화면에서 지움 20260402 원복시 그리드 gridHeight2 높이 변경 해야함 -->
      <div v-if="false">
      <div class="main-table-container">
        <!-- === 메인 달력 테이블 === -->
        <table class="main-table">
          <thead>
            <tr>
              <!-- <th>목표입력</th> -->
              <th>목표입력</th>
              <th></th>
              <th>주간</th>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <!-- 로딩 중 -->
          <tbody v-if="mainTableLoading">
            <tr>
              <td :colspan="10">데이터 로딩 중...</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
          <!-- 데이터 있음 -->
          <tbody
            v-else-if="
              weeklySalesData.qtyWeeks && weeklySalesData.qtyWeeks.length > 0
            "
          >
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <!-- 수량 행 -->
              <tr>
                <td
                  v-if="index === 0"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem"
                >
                  월목표
                </td>
                <td
                  v-if="index === 1"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.monthlyGoalQty?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 3"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem"
                >
                  오늘목표
                </td>
                <td
                  v-if="index === 4"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.dailyGoalQty?.toLocaleString() || "-" }}
                </td>
                <!-- <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  수량
                </td> -->
                <td
                  v-if="index === 0"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem; writing-mode: unset;"
                >
                  누계
                </td>
                <td
                  v-if="index === 1"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold; writing-mode: unset;"
                >
                  {{ summaryInfo.totalQty?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 3"
                  style="color: red; background-color: #d0d0d0; font-size: 1rem; writing-mode: unset;"
                >
                  예상
                </td>
                <td
                  v-if="index === 4"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold; writing-mode: unset;"
                >
                  {{ summaryInfo.projectedQtySum?.toLocaleString() || "-" }}
                </td>
                <td>{{ qtyWeek.week }}주</td>
                <td>{{ qtyWeek.sun }}</td>
                <td>{{ qtyWeek.mon }}</td>
                <td>{{ qtyWeek.tue }}</td>
                <td>{{ qtyWeek.wed }}</td>
                <td>{{ qtyWeek.thu }}</td>
                <td>{{ qtyWeek.fri }}</td>
                <td>{{ qtyWeek.sat }}</td>
              </tr>
            </template>
            <!-- <tr>
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalQty?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedQtySum?.toLocaleString() || "-" }}
              </td>
            </tr> -->

            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <!-- 점수 행 -->
              <tr class="score-row">
                <td
                  v-if="index === 0"
                  style="background-color: #d9d996; font-size: 1rem"
                >
                  월목표
                </td>
                <td
                  v-if="index === 1"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.monthlyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 3"
                  style="background-color: #d9d996; font-size: 1rem"
                >
                  오늘목표
                </td>
                <td
                  v-if="index === 4"
                  :rowspan="3"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.dailyGoalPoints?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  점수
                </td>
                <td>{{ weeklySalesData.pointWeeks[index].week }}주</td>
                <td>{{ weeklySalesData.pointWeeks[index].sun || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].mon || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].tue || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].wed || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].thu || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].fri || "" }}</td>
                <td>{{ weeklySalesData.pointWeeks[index].sat || "" }}</td>
              </tr>
            </template>
            <tr class="score-row">
              <td colspan="2">누계</td>
              <td colspan="2">
                {{ summaryInfo.totalPoints?.toLocaleString() || "-" }}
              </td>
              <td colspan="2">예상</td>
              <td colspan="2">
                {{ summaryInfo.projectedPointSum?.toLocaleString() || "-" }}
              </td>
            </tr>
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <!-- 인원적합도 행 -->
              <tr class="match-row">
                <td
                  v-if="index === 0"
                  style="background-color: #f2b1a5; font-size: 1rem"
                >
                  근무TO
                </td>
                <td
                  v-if="index === 1"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.personnelTO?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 2"
                  style="background-color: #f2b1a5; font-size: 1rem"
                >
                  근무
                </td>
                <td
                  v-if="index === 3"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.personnelActual?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 4"
                  style="background-color: #f2b1a5; font-size: 0.9rem"
                >
                  오늘적합도
                </td>
                <td
                  v-if="index === 5"
                  :rowspan="2"
                  style="font-size: 1rem; font-weight: bold"
                >
                  {{ summaryInfo.todayMatch?.toLocaleString() || "-" }}
                </td>
                <td
                  v-if="index === 0"
                  :rowspan="weeklySalesData.qtyWeeks.length + 1"
                >
                  인원적합도
                </td>
                <td>{{ weeklySalesData.matchWeeks[index].week }}주</td>
                <td>{{ weeklySalesData.matchWeeks[index].sun }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].mon }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].tue }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].wed }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].thu }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].fri }}</td>
                <td>{{ weeklySalesData.matchWeeks[index].sat }}</td>
              </tr>
            </template>
            <tr class="match-row">
              <td colspan="2">평균</td>
              <td colspan="2">
                {{ summaryInfo.avgMatch?.toLocaleString() || "-" }}
              </td>
              <td colspan="2"></td>
              <td colspan="2"></td>
            </tr>
          </tbody>
          <!-- 데이터 없음 -->
          <tbody v-else>
            <tr>
              <td :colspan="10">데이터가 없습니다.</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
        </table>
      </div>
      </div>
      <!-- 버튼을 감싸는 컨테이너 추가 -->
      <!-- <div class="toggle-button-container">
        <button @click="toggleExpand" class="toggle-button">
          {{ isExpanded ? "▲ 펼치기" : "▼ 접기" }}
        </button>
      </div> -->
    </div>

    <div class="right-section">
      <div class="right-section-top">
        <div class="buttons-container" v-if="this.userInfo?.OGN_FG == '00'">
          <button style="background-color: #ffff00; border-color: #ffff00">
            집중지도
          </button>
          <!-- @click="refreshRightGrid('2')" // 20260122 배경색 변경(육상용 팀장님 요청)-->
          <button style="background-color: #adffa7; border-color: #adffa7">
            교육매장
          </button>
          <!-- @click="refreshRightGrid('1')" // 20260122 배경색 변경(육상용 팀장님 요청)-->
          <button style="background-color: #98c5fc; border-color: #98c5fc">
            적자관리
          </button>
          <!-- @click="refreshRightGrid('3')" // 20260122 배경색 변경(육상용 팀장님 요청)-->
        </div>
        <button
            class="refresh-btn"
            @click="leftGridCopy"
            v-if="['TB관리자1','zzzooo0212'].includes(userInfo?.userId)"
          >
            복사
        </button>
        
        <div class="right-info-container">
          <div class="right-info-left">
            <div @click="openAnalysisPopup" class="right-info-label">FC</div>
            <select
              v-model="selectedCenter"
              @change="onCenterChange"
              class="center-select-box"
              :disabled="userInfo && userInfo.OGN_FG === '01'"
              style="
                width: 90px;
                height: 100%;
                padding: 5px;
                border-radius: 5px;
                border: 1px solid #ccc;
                font-size: 0.9rem;
              "
            >
              <option
                v-for="centerItem in centerData"
                :key="centerItem.BRANCH_CD"
                :value="centerItem"
              >
                {{ centerItem.BRANCH_NM }}
              </option>
            </select>
          </div>
          <div class="right-info-right">
            <div class="right-info-label">매장명</div>
            <input
              type="text"
              placeholder="검색"
              @input="onQuickFilterChanged"
              style="
                width: 100px;
                height: 100%;
                padding: 5px;
                border-radius: 5px;
                border: 1px solid #ccc;
                font-size: 0.9rem;
              "
            />
          </div>
        </div>
      </div>
      <div @contextmenu.prevent>
        <ag-grid-vue
          class="ag-se-balham right-grid"
          :theme="theme"
          :style="{ width: '100%', height: gridHeight1 + 'rem' }"
          :rowData="rowData1"
          :columnDefs="columnDefs1"
          :gridOptions="gridOptions1"
          :rowSelection="rowSelection"
          @grid-ready="onRightGridReady"
          @cell-clicked="onCellClicked"
          @cellContextMenu="onCellContextMenu"
          :suppressContextMenu="true"
          :pinnedBottomRowData="pinnedBottomRow"
        ></ag-grid-vue>
      </div>
      <!-- 오른쪽 테이블 -->
      <div class="analysis-section">
        <table class="main-table">
          <tbody v-if="mainTableLoading">
            <tr>
              <td :colspan="10">데이터 로딩 중...</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>

          <tbody class="side-table">
            <tr>
              <td
                style="width: 25%; color: red; background-color: #ffff00;"
              >
                당월최고수량
              </td>
              <td
                style="width: 25%; color: red; background-color: #ffff00;"
              >
                당월수량
              </td>
              <td
                style="width: 25%; color: red; background-color: #ffff00;"
              >
                예상
              </td>
              <td
                style="width: 25%; color: red; background-color: #ffff00;"
              >
                달성률
              </td>
            </tr>

            <tr>
              <td style="font-size: 1rem; font-weight: bold">
                <!-- {{ summaryInfo.monthlyGoalQty?.toLocaleString() || "-" }}  당월 최고수량 으로 바꿈 20260420-->
                {{ summaryInfo.monthlyMaxGoalQty?.toLocaleString() || "-" }}
              </td>
              <td style="font-size: 1rem; font-weight: bold">
                {{ summaryInfo.totalQty?.toLocaleString() || "-" }}
              </td>
              <td style="font-size: 1rem; font-weight: bold">
                {{ summaryInfo.projectedQtySum?.toLocaleString() || "-" }}
              </td>
              <td style="font-size: 1rem; font-weight: bold; writing-mode: unset;">
                {{ 
                  // summaryInfo.monthlyGoalQty && summaryInfo.projectedQtySum
                  //   ? ((summaryInfo.projectedQtySum / summaryInfo.monthlyGoalQty) * 100).toFixed(1) + '%'
                  summaryInfo.monthlyMaxGoalQty && summaryInfo.projectedQtySum
                    ? ((summaryInfo.projectedQtySum / summaryInfo.monthlyMaxGoalQty) * 100).toFixed(1) + '%'
                    : '-'
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="main-table">
          <thead>
            <tr>
              <!-- <th>목표입력</th> -->
              <!-- <th>목표입력</th>
              <th></th> -->
              <th>주간</th>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <!-- 로딩 중 -->
          <tbody v-if="mainTableLoading">
            <tr>
              <td :colspan="10">데이터 로딩 중...</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
          <!-- 데이터 있음 -->
          <tbody
            v-else-if="
              weeklySalesData.qtyWeeks && weeklySalesData.qtyWeeks.length > 0
            "
          >
            <template
              v-for="(qtyWeek, index) in weeklySalesData.qtyWeeks"
              :key="'week-group-' + index"
            >
              <!-- 수량 행 -->
              <tr>
                <td>{{ qtyWeek.week }}주</td>
                <td>{{ qtyWeek.sun }}</td>
                <td>{{ qtyWeek.mon }}</td>
                <td>{{ qtyWeek.tue }}</td>
                <td>{{ qtyWeek.wed }}</td>
                <td>{{ qtyWeek.thu }}</td>
                <td>{{ qtyWeek.fri }}</td>
                <td>{{ qtyWeek.sat }}</td>
              </tr>
            </template>       
          </tbody>
          <!-- 데이터 없음 -->
          <tbody v-else>
            <tr>
              <td :colspan="10">데이터가 없습니다.</td>
              <!-- Colspan 수정 -->
            </tr>
          </tbody>
        </table>
        <!-- 확인자  -->
        <table class="confirmation-table">
          <thead>
            <tr>
              <th style="width: 20%">확인자</th>
              <th style="width: 30%">확인자서명</th>
              <th style="width: 40%">서명일시</th>
              <th style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in confirmations" :key="index">
              <td>{{ item.role }}</td>
              <td>
                <input
                  type="text"
                  v-model="item.signature"
                  class="confirmation-input"
                  placeholder="서명"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="item.signedDt"
                  class="confirmation-input"
                  maxlength="8"
                  :placeholder="new Date().toISOString().slice(0,10).replace(/-/g,'')"
                  :disabled="['재경부1','재경부2','감사팀장'].includes(item.role)"
                  />
                  <!-- disabled -->
              </td>
              <td @click="saveConfirmation(item)" class="confirmation-save-cell">
                <div class="confirmation-save-btn">저장</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- v-if="false" 화면에서 지움 20260402-->
        <div v-if="false">
        <table class="analysis-table" >
          <thead>
            <tr>
              <th>사업주분석1</th>
              <th style="background-color: #ffd9d9">전월 흑자</th>
              <th style="background-color: #d2e9fd">전월 적자</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th style="background-color: #ffd9d9">전월누계</th>
              <!-- 전월 흑자 합계 -->
              <td
                :style="{
                  color: analysisResults.lastMonth.sum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.lastMonth.sum.toLocaleString() }}
              </td>
              <!-- 전월 적자 합계 -->
              <td
                :style="{
                  color: analysisResults.lastMonth.negSum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.lastMonth.negSum.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #ffd9d9">점포수</th>
              <!-- 전월 흑자 점포수 -->
              <td>{{ analysisResults.lastMonth.count.toLocaleString() }}</td>
              <!-- 전월 적자 점포수 -->
              <td>{{ analysisResults.lastMonth.negCount.toLocaleString() }}</td>
            </tr>
            <tr>
              <th style="background-color: #ffd9d9">비율</th>
              <!-- 전월 흑자 비율 -->
              <td>{{ analysisResults.lastMonth.ratio.toFixed(1) }}%</td>
              <!-- 전월 적자 비율 -->
              <td>{{ analysisResults.lastMonth.negRatio.toFixed(1) }}%</td>
            </tr>
            <tr>
              <th style="background-color: #d2e9fd">당월</th>
              <!-- 당월 흑자 -->
              <!-- 당월 흑자 합계 -->
              <td
                :style="{
                  color: analysisResults.currentMonth.sum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.currentMonth.sum.toLocaleString() }}
              </td>
              <!-- 당월 적자 합계 -->
              <td
                :style="{
                  color:
                    analysisResults.currentMonth.negSum > 0 ? 'red' : 'blue',
                }"
              >
                {{ analysisResults.currentMonth.negSum.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #d2e9fd">점포수</th>
              <!-- 당월 흑자 점포수 -->
              <td>{{ analysisResults.currentMonth.count.toLocaleString() }}</td>
              <!-- 당월 적자 점포수 -->
              <td>
                {{ analysisResults.currentMonth.negCount.toLocaleString() }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #d2e9fd">비율</th>
              <!-- 당월 흑자 비율 -->
              <td>{{ analysisResults.currentMonth.ratio.toFixed(1) }}%</td>
              <!-- 당월 적자 비율 -->
              <td>{{ analysisResults.currentMonth.negRatio.toFixed(1) }}%</td>
            </tr>
          </tbody>
        </table>

        <table class="analysis-table">
          <thead>
            <tr>
              <th>사업주분석2</th>
              <th style="background-color: #fd99b7">흑자사업주</th>
              <th style="background-color: #98c5fc">적자사업주</th>
            </tr>
          </thead>
          <tbody>
            <!-- 당월 흑자 섹션 -->
            <tr>
              <!-- 행 제목: 당월 흑자 (3행 병합) -->
              <th style="background-color: #fd99b7">흑자</th>
              <!-- 전월 흑자 그룹 중 당월 흑자 합계 (lPPSum) -->
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastPositive.currentPositiveSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveSum.toLocaleString()
                }}
              </td>
              <!-- 전월 적자 그룹 중 당월 흑자 합계 (lMPSum) -->
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastNegative.currentPositiveSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveSum.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #fd99b7">점포수</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveCount.toLocaleString()
                }}
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveCount.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <!-- 비율 (그룹 내) -->
              <th style="background-color: #fd99b7">비율</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentPositiveRatio.toFixed(
                    1,
                  )
                }}%
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentPositiveRatio.toFixed(
                    1,
                  )
                }}%
              </td>
            </tr>

            <!-- 당월 적자 섹션 -->
            <tr>
              <!-- 행 제목: 당월 적자 (3행 병합) -->
              <th style="background-color: #98c5fc">적자</th>
              <!-- 전월 흑자 그룹 중 당월 적자 합계 (lPMSum) -->
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastPositive.currentNegativeSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeSum.toLocaleString()
                }}
              </td>
              <!-- 전월 적자 그룹 중 당월 적자 합계 (lMMSum) -->
              <td
                :style="{
                  color:
                    analysisResults.analysis2.lastNegative.currentNegativeSum >
                    0
                      ? 'red'
                      : 'blue',
                }"
              >
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeSum.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #98c5fc">점포수</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeCount.toLocaleString()
                }}
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeCount.toLocaleString()
                }}
              </td>
            </tr>
            <tr>
              <th style="background-color: #98c5fc">비율</th>
              <td>
                {{
                  analysisResults.analysis2.lastPositive.currentNegativeRatio.toFixed(
                    1,
                  )
                }}%
              </td>
              <td>
                {{
                  analysisResults.analysis2.lastNegative.currentNegativeRatio.toFixed(
                    1,
                  )
                }}%
              </td>
            </tr>
          </tbody>
        </table>
        </div><!-- v-if="false" 화면에서 지움 20260402-->
        <div v-if="showAnalysisPopup" class="analysis-modal-overlay">
        <div class="analysis-modal">
          <div class="analysis-modal-header">
            <h4>사업주 분석</h4>
            <button @click="closeAnalysisPopup" class="analysis-modal-close-btn">닫기</button>
          </div>
          <div class="analysis-modal-body">
            <table class="analysis-table" >
              <thead>
                <tr>
                  <th>사업주분석1</th>
                  <th style="background-color: #ffd9d9">전월 흑자</th>
                  <th style="background-color: #d2e9fd">전월 적자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th style="background-color: #ffd9d9">전월누계</th>
                  <!-- 전월 흑자 합계 -->
                  <td
                    :style="{
                      color: analysisResults.lastMonth.sum > 0 ? 'red' : 'blue',
                    }"
                  >
                    {{ analysisResults.lastMonth.sum.toLocaleString() }}
                  </td>
                  <!-- 전월 적자 합계 -->
                  <td
                    :style="{
                      color: analysisResults.lastMonth.negSum > 0 ? 'red' : 'blue',
                    }"
                  >
                    {{ analysisResults.lastMonth.negSum.toLocaleString() }}
                  </td>
                </tr>
                <tr>
                  <th style="background-color: #ffd9d9">점포수</th>
                  <!-- 전월 흑자 점포수 -->
                  <td>{{ analysisResults.lastMonth.count.toLocaleString() }}</td>
                  <!-- 전월 적자 점포수 -->
                  <td>{{ analysisResults.lastMonth.negCount.toLocaleString() }}</td>
                </tr>
                <tr>
                  <th style="background-color: #ffd9d9">비율</th>
                  <!-- 전월 흑자 비율 -->
                  <td>{{ analysisResults.lastMonth.ratio.toFixed(1) }}%</td>
                  <!-- 전월 적자 비율 -->
                  <td>{{ analysisResults.lastMonth.negRatio.toFixed(1) }}%</td>
                </tr>
                <tr>
                  <th style="background-color: #d2e9fd">당월</th>
                  <!-- 당월 흑자 -->
                  <!-- 당월 흑자 합계 -->
                  <td
                    :style="{
                      color: analysisResults.currentMonth.sum > 0 ? 'red' : 'blue',
                    }"
                  >
                    {{ analysisResults.currentMonth.sum.toLocaleString() }}
                  </td>
                  <!-- 당월 적자 합계 -->
                  <td
                    :style="{
                      color:
                        analysisResults.currentMonth.negSum > 0 ? 'red' : 'blue',
                    }"
                  >
                    {{ analysisResults.currentMonth.negSum.toLocaleString() }}
                  </td>
                </tr>
                <tr>
                  <th style="background-color: #d2e9fd">점포수</th>
                  <!-- 당월 흑자 점포수 -->
                  <td>{{ analysisResults.currentMonth.count.toLocaleString() }}</td>
                  <!-- 당월 적자 점포수 -->
                  <td>
                    {{ analysisResults.currentMonth.negCount.toLocaleString() }}
                  </td>
                </tr>
                <tr>
                  <th style="background-color: #d2e9fd">비율</th>
                  <!-- 당월 흑자 비율 -->
                  <td>{{ analysisResults.currentMonth.ratio.toFixed(1) }}%</td>
                  <!-- 당월 적자 비율 -->
                  <td>{{ analysisResults.currentMonth.negRatio.toFixed(1) }}%</td>
                </tr>
              </tbody>
            </table>

            <table class="analysis-table">
              <thead>
                <tr>
                  <th>사업주분석2</th>
                  <th style="background-color: #fd99b7">흑자사업주</th>
                  <th style="background-color: #98c5fc">적자사업주</th>
                </tr>
              </thead>
              <tbody>
                <!-- 당월 흑자 섹션 -->
                <tr>
                  <!-- 행 제목: 당월 흑자 (3행 병합) -->
                  <th style="background-color: #fd99b7">흑자</th>
                  <!-- 전월 흑자 그룹 중 당월 흑자 합계 (lPPSum) -->
                  <td
                    :style="{
                      color:
                        analysisResults.analysis2.lastPositive.currentPositiveSum >
                        0
                          ? 'red'
                          : 'blue',
                    }"
                  >
                    {{
                      analysisResults.analysis2.lastPositive.currentPositiveSum.toLocaleString()
                    }}
                  </td>
                  <!-- 전월 적자 그룹 중 당월 흑자 합계 (lMPSum) -->
                  <td
                    :style="{
                      color:
                        analysisResults.analysis2.lastNegative.currentPositiveSum >
                        0
                          ? 'red'
                          : 'blue',
                    }"
                  >
                    {{
                      analysisResults.analysis2.lastNegative.currentPositiveSum.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th style="background-color: #fd99b7">점포수</th>
                  <td>
                    {{
                      analysisResults.analysis2.lastPositive.currentPositiveCount.toLocaleString()
                    }}
                  </td>
                  <td>
                    {{
                      analysisResults.analysis2.lastNegative.currentPositiveCount.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <!-- 비율 (그룹 내) -->
                  <th style="background-color: #fd99b7">비율</th>
                  <td>
                    {{
                      analysisResults.analysis2.lastPositive.currentPositiveRatio.toFixed(
                        1,
                      )
                    }}%
                  </td>
                  <td>
                    {{
                      analysisResults.analysis2.lastNegative.currentPositiveRatio.toFixed(
                        1,
                      )
                    }}%
                  </td>
                </tr>

                <!-- 당월 적자 섹션 -->
                <tr>
                  <!-- 행 제목: 당월 적자 (3행 병합) -->
                  <th style="background-color: #98c5fc">적자</th>
                  <!-- 전월 흑자 그룹 중 당월 적자 합계 (lPMSum) -->
                  <td
                    :style="{
                      color:
                        analysisResults.analysis2.lastPositive.currentNegativeSum >
                        0
                          ? 'red'
                          : 'blue',
                    }"
                  >
                    {{
                      analysisResults.analysis2.lastPositive.currentNegativeSum.toLocaleString()
                    }}
                  </td>
                  <!-- 전월 적자 그룹 중 당월 적자 합계 (lMMSum) -->
                  <td
                    :style="{
                      color:
                        analysisResults.analysis2.lastNegative.currentNegativeSum >
                        0
                          ? 'red'
                          : 'blue',
                    }"
                  >
                    {{
                      analysisResults.analysis2.lastNegative.currentNegativeSum.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th style="background-color: #98c5fc">점포수</th>
                  <td>
                    {{
                      analysisResults.analysis2.lastPositive.currentNegativeCount.toLocaleString()
                    }}
                  </td>
                  <td>
                    {{
                      analysisResults.analysis2.lastNegative.currentNegativeCount.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <th>비율</th>
                  <td>
                    {{
                      analysisResults.analysis2.lastPositive.currentNegativeRatio.toFixed(
                        1,
                      )
                    }}%
                  </td>
                  <td>
                    {{
                      analysisResults.analysis2.lastNegative.currentNegativeRatio.toFixed(
                        1,
                      )
                    }}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
        <!-- 점명 우클릭 팝업 (감사 / 점정보 수정 UI) -->
        <div v-if="showAuditmodal" class="audit-modal-overlay">
          <div class="audit-modal">
            <div class="audit-header">
              <div class="audit-title">감사기록 / 매장정보</div>
              <button class="audit-close" @click="closeAuditmodal">X</button>
            </div>
            <div class="audit-body">
              <div class="store-info">
                <div><strong>매장명 :</strong> {{ auditShopNm }}</div>
                <!-- <div><strong>매장코드 :</strong> {{ auditShopCd }}</div> -->
              </div>
              <div class="audit-controls">
                <label>날짜:</label>
                <!-- <input type="date" v-model="auditDate" /> -->
                <input
                  type="date"
                  v-model="auditDate"
                  @change="onAuditDateChange"
                />
                <label>구분:</label>
                <select v-model="auditKind">
                  <option value="해지">해지</option>
                  <option value="감사">감사</option>
                </select>
                <label>점수:</label>
                <input
                  type="text"
                  v-model="auditScore"
                  :disabled="auditKind !== '감사'"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                />
                <button @click="addAudit">일정 추가</button>
              </div>

              <div class="audit-grid">
                <table class="audit-table">
                  <thead>
                    <tr>
                      <th>일자</th>
                      <th>감사자</th>
                      <th>구분</th>
                      <th>점수</th>
                      <th>삭제</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(r, idx) in auditList" :key="idx">
                      <td hidden><input type="text" v-model="r.lId" /></td>
                      <!-- <td><input type="text" v-model="r.date" readonly/></td> -->
                      <!-- <td><input type="text" v-model="r.person" readonly/></td> -->
                      <!-- <td><input type="text" v-model="r.kind" readonly/></td> -->
                      <!-- <td><input type="text" v-model="r.score" readonly/></td> -->
                      <td>{{ r.date }}</td>
                      <td>{{ r.person }}</td>
                      <td>{{ r.kind }}</td>
                      <td>{{ r.score }}</td>
                      <td>
                        <button @click="removeAuditRow(idx)">삭제</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="audit-footer">
              <button @click="closeAuditmodal">닫기</button>
            </div>
          </div>
        </div>
        <!-- / 점명 우클릭 팝업 -->
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "SeListPage",
  components: {
    AgGridVue,
  },
  props: {
    useNewSeListGrid: Boolean,
  },
  data() {
    return {
      warningFlag:false, // 화면 깜빡 여부
      
      userInfo: null, // 로그인한 사용자 정보
      userId: null, // 로그인한 사용자 정보

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        borderColor: "#c0c0c0",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      leftGridApi: null,
      rightGridApi: null,

      rowData1: [], // AG Grid에 표시할 데이터

      centerData: [], // 본부 데이터

      selectedCenter: "", // 선택된 본부

      rowData2: [], // AG Grid에 표시할 데이터

      mainTableData: [], // 메인 테이블 데이터

      totalCustomers: 0, // 총고객수

      availableCustomers: 0, // 가용 고객수

      selectedShop: null,

      selectedRowData: null, // 선택된 행의 데이터를 저장할 속성

      isExpanded: true, // 펼치기/접기 상태

      mainTableLoading: false, // 메인 테이블 로딩 상태

      showAnalysisPopup: false, // 사업주 분석 팝업 표시 상태

      // 확인자 
      confirmations: [
        { role: "사업주", signature: "", signedDt: "", seqNo: 1 },
        { role: "담당감사", signature: "", signedDt: "", seqNo: 2 },
        { role: "담당FC", signature: "", signedDt: "", seqNo: 3 },
        { role: "재경부1", signature: "", signedDt: "", seqNo: 4 },
        { role: "재경부2", signature: "", signedDt: "", seqNo: 5 },
        { role: "감사팀장", signature: "", signedDt: "", seqNo: 6 },
      ],

      ownerGoal: "",
      ownerHow: "",
      opinion1: "",
      opinion2: "",
      businessMap: "",
      contractConfirm: "",

      // audit / 우클릭 패널 상태
      showAuditmodal: false,
      lID: "",
      auditShopNm: "",
      auditShopCd: "",
      auditDate: new Date().toLocaleDateString("sv"),
      auditKind: "해지",
      auditScore: "",
      auditList: [],

      indexGoalList: [],

      rowSelection: { mode: "singleRow", checkboxes: false },

      rowHeight: window.innerWidth > 1024 ? 20 : 15.5, // 행 높이

      gridHeight1: window.innerWidth > 1024 ? 20 : 14, // 그리드1 높이

      // gridHeight2: window.innerWidth > 1024 ? 41.5 : 32.5, // 그리드2 높이
      gridHeight2: !this.useNewSeListGrid ? (window.innerWidth > 1024 ? 53 : 32.5) : (window.innerWidth > 1024 ? 37.7 : 32.5), // 그리드2 높이

      columnDefs1: [
        {
          headerName: "",
          field: "rowIndex",
          // width: 28,
          // maxWidth: 29,
          flex: 0.8,
          valueGetter: "node.rowIndex + 1",
          sortable: false,
          cellStyle: {
            color: "black",
            "background-color": "#f0f0f0",
            "text-align": "center",
          },
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          // width: 28,
          // maxWidth: 29,
          flex: 0.9,
          cellStyle: { "text-align": "center" },
          colSpan: (params) => {
            // 조건에 따라 열 병합
            if (params.data && params.data.VAN_BIZ_NO.includes("합계")) {
              return 2; // 두 개의 열을 병합
            }
            return 1; // 기본적으로 한 개의 열
          },
        },
        {
          headerName: "점명",
          field: "SHOP_NM",
          // width: 58,
          // maxWidth: 60,
          flex: 1.7,
          cellStyle: { "text-align": "center" }, // 20260122 배경색 변경(육상용 팀장님 요청)
          // cellStyle: (params) => {
          //   // 기본 스타일 (기존 스타일 유지)
          //   const baseStyle = { "text-align": "center" };

          //   // params.data와 params.data.TYPE_FG가 있는지 확인
          //   // TYPE_FG 필드가 백엔드 데이터에 포함되어 있어야 합니다.
          //   if (params.data && params.data.TYPE_FG) {
          //     const typeFg = params.data.TYPE_FG; // TYPE_FG 값 가져오기
          //     // TYPE_FG 값에 따라 배경색 결정 (예시 조건 및 색상)
          //     // 실제 TYPE_FG 값과 원하는 색상으로 변경하세요.
          //     if (typeFg === 1) {
          //       // 예: TYPE_FG가 '1'일 경우
          //       // 기본 스타일과 배경색 스타일을 병합하여 반환
          //       return { ...baseStyle, "background-color": "#00FF00" }; // 연한 노란색
          //     } else if (typeFg === 2) {
          //       // 예: TYPE_FG가 '2'일 경우
          //       return { ...baseStyle, "background-color": "#FFFF00" }; // 연한 녹색
          //     } else if (typeFg === 3) {
          //       // 예: TYPE_FG가 '3'일 경우
          //       return { ...baseStyle, "background-color": "#FFFFFF" }; // 연한 파란색
          //     }
          //     // 필요에 따라 다른 TYPE_FG 값에 대한 else if 조건을 추가할 수 있습니다.
          //   }

          //   // 조건에 맞지 않거나 데이터(TYPE_FG)가 없으면 기본 스타일만 반환
          //   return baseStyle;
          // },
        },
        {
          headerName: "당월\n수익",
          field: "PROFIT",
          wrapHeaderText: true,
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          // width: 43,
          // maxWidth: 100,
          flex: 1.3,
          cellStyle: (params) => {
            // 기본 스타일 객체
            let style = {};
            // 텍스트 색상 결정 (기존 로직)
            if (params.value != null) {
              // null 체크 추가
              style.color = params.value < 0 ? "blue" : "red";
            }

            // 배경색 결정 (새로운 로직)
            // params.data와 LASTPROFIT 값이 있는지 확인
            // if (params.data && params.data.LASTPROFIT != null) {
            //   const lastProfitValue = Number(params.data.LASTPROFIT);
            //   if (lastProfitValue >= 7000) {
            //     style["background-color"] = "#99F0FF";
            //   }
            // }
            style["background-color"] = "#ffff00"; // 20260122 배경색 변경(육상용 팀장님 요청)
            return style; // 최종 스타일 객체 반환
          },

          // suppressSizeToFit: true,
        },
        {
          headerName: "전월까지\n보증예측",
          field: "LASTPROFIT",
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          // width: 46,
          // maxWidth: 46,
          flex: 1.3,
          cellStyle: (params) => {
            // 기본 스타일 객체
            let style = {};
            // 텍스트 색상 결정 (기존 로직)
            if (params.value != null) {
              // null 체크 추가
              style.color = params.value < 0 ? "blue" : "red";
            }

            // 배경색 결정 (새로운 로직)
            // params.data와 LASTPROFIT 값이 있는지 확인
            // if (params.data && params.data.LASTPROFIT != null) {
            //   const lastProfitValue = Number(params.data.LASTPROFIT);
            //   if (lastProfitValue >= 7000) {
            //     style["background-color"] = "#99F0FF"; // 연한 노란색 배경 (원하는 색상으로 변경 가능)
            //   }
            // }
            style["background-color"] = "#ffff00"; // 20260122 배경색 변경(육상용 팀장님 요청)
            return style; // 최종 스타일 객체 반환
          },
        },
        {
          headerName: "사업보증\n예측금",
          field: "TOTALPROFITSUM",
          wrapHeaderText: true,
          valueGetter: (params) => {
            // 전월 실선미 - 당월수익 계산
            const lastProfit = params.data.LASTPROFIT || 0; // 전월 실선미
            const profit = params.data.PROFIT || 0; // 당월수익
            return lastProfit + profit; // 계산된 값 반환
          },
          valueFormatter: (params) => {
            return Number(params.value).toLocaleString();
          },
          // width: 53,
          // maxWidth: 53,
          flex: 1.5,
          cellStyle: (params) =>
            params.value < 0 ? { color: "blue" } : { color: "red" },
          // "padding-right": "5px",

          colSpan: (params) => {
            // 조건에 따라 열 병합
            if (params.data && params.data.VAN_BIZ_NO.includes("합계")) {
              return 2; // 두 개의 열을 병합
            }
            return 1; // 기본적으로 한 개의 열
          },
        },
        {
          headerName: "보증금\n적립방법",
          wrapHeaderText: true,
          field: "TRBIZ_TYPE",
          // width: 29,
          // maxWidth: 30,
          flex: 1.2,
          minWidth: 35,
          cellStyle: { "text-align": "center" },
        },
      ],

      columnDefs2: [
        {
          headerName: "",
          field: "year",
          valueGetter: (params) => this.useNewSeListGrid ? params.data.year : (params.node.rowIndex),
          pinned: "left",
          // rowSpan: this.calculateRowSpan,  // 20260402 수정
          // cellClass: "year-cell",
          rowSpan: (params) => this.useNewSeListGrid ? this.calculateRowSpan(params) : 1,
          cellClass: () => this.useNewSeListGrid ? "year-cell" : "",
          width: 22,
          maxWidth: 22,
          flex: 0.5,
          suppressSizeToFit: true,
          cellStyle: this.getRowStyleForGrid2,
        }, // 년도 열
        {
          headerName: "",
          field: "gubun",
          pinned: "left",
          width: 69,
          cellStyle: this.getRowStyleForGrid2,
          tooltipValueGetter: (params) => {
            if (params.data && ["예정약금", "실제약금", "매출액","수수료","판가","상계금액","상계차액","목표수익"].includes(params.data.gubun)) {
              return "단위: 원/10,000";
            }
          },
        },
        // 월별 컬럼 정의 (반복문 사용)
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `${i + 1}month`,
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle, // 공통 셀 스타일 사용
          editable: (params) => {
            const {
              EMP_CLASS_NM: empClassNm,
              OGN_FG: ognFg,
              EMP_DEPT_NM: empDeptNm,
            } = this.userInfo ?? {};

            const EMP_CLASS_NM = ["부회장", "대표이사", "본부장"];
            const EMP_DEPT_NM = ["관리자팀"];
            const OGN_FG = "00";

            const isEmpClassNm = EMP_CLASS_NM.includes(empClassNm);
            const isOgnFg = ognFg !== OGN_FG;
            const isEmpDeptNm = EMP_DEPT_NM.includes(empDeptNm);

            const isEditable = isEmpClassNm || isOgnFg || isEmpDeptNm;

            // 계약수량 전용 권한 (예: 관리자팀만 가능하게)
            // const isEditableContract = isOgnFg || isEmpDeptNm;

            // if (params.data.gubun === "계약수량") {
            //   return isEditableContract;   // 계약수량은 별도 권한 조건
            // }
            // 목표수익   20260825 추가
            const isEditableContract = isOgnFg || isEmpDeptNm;
            if (params.data.gubun === "목표수익") {
              return isEditableContract;   // 목표수익은 별도 권한 조건
            }

            if (!isEditable) return false;
            return ["컨설턴트", "사업주명", "부점장명"].includes(
              params.data.gubun,
            );
          },
          // 목표수익   20260825 추가
          cellEditorParams: (params) => {
            if (params.data.gubun === "목표수익") {
              return { maxLength: 5,};
            }
            return null; // 다른 경우는 제한 없음
          },
        })),
        {
          headerName: "합계",
          field: "totalCnt",
          flex: 1,
          valueFormatter: this.commonValueFormatter, // 공통 포맷터 사용
          cellStyle: this.commonCellStyle,
        },
      ],

      defaultColDef: {
        resizable: true, // 열 크기 조정 가능
        sortable: true, // 정렬 가능
        // filter: true, // 필터 가능
        // minwidth: 50,
        headerHeight: 20,
        wrapHeaderText: true,
      },

      gridOptions2: {
        // enableSorting: true,
        // animateRows: true,
        quickFilterText: "",
        suppressNoRowsOverlay: true, // 데이터가 없을 때 오버레이 숨김
        // tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 0,
        suppressRowTransform: true, // 행 병합 시 필수 (렌더링 최적화 및 오류 방지)
        defaultColDef: {
          resizable: false, // 열 크기 조정 가능
          sortable: false, // 정렬 가능
          tooltipValueGetter: (params) => {
            // 목표수익   20260825 추가
            if (params.data.gubun === "목표수익") {
              return "목표수익은 5자리까지만 입력 가능합니다";
            }
            // 기본값은 defaultColDef 설정을 따라감
            return params.value;
          },
        },
        cellEditor: 'agTextCellEditor',
        cellEditorParams: {
          maxLength: 5
        },
        getRowStyle: (params) => {
          if (!params.data || !params.data.year) {
            return null; // 데이터가 없으면 기본 스타일 반환
          }

          const currentYear = new Date().getFullYear();
          const currentYY = parseInt(currentYear.toString().substring(2, 4));

          let yearStr = params.data.year.toString().replace("년", "");
          if (yearStr.length === 4) {
            yearStr = yearStr.substring(2, 4);
          }
          const yearYY = parseInt(yearStr);
          const diff = currentYY - yearYY;

          if (diff === 7) {
            return { background: "#97ecff" };
          }else if (diff === 6) {
            return { background: "#b4bfff" };
          } else if (diff === 5) {
            return { background: "#ead6bf" };
          } else if (diff === 4) {
            return { background: "#bef29e" };
          } else if (diff === 3) {
            return { background: "#fff0fd" };
          } else if (diff === 2) {
            return { background: "#dcf3fc" };
          } else if (diff === 1) {
            return { background: "#f1fcb8" };
          } else if (diff === 0) {
            return { background: "#c8fdd1" };
          }
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        headerHeight: 20,
      },

      gridOptions1: {
        quickFilterText: "",
        suppressNoRowsOverlay: true, // 데이터가 없을 때 오버레이 숨김
        suppressHorizontalScroll: true,
        tooltipShowMode: "whenTruncated",
        tooltipShowDelay: 0,
        defaultColDef: {
          tooltipValueGetter: (params) => params.value,
        },
        getRowStyle: (params) => {
          if (!params.data || !params.data.year) {
            return null; // 데이터가 없으면 기본 스타일 반환
          }
        },

        getRowHeight: (params) => {
          if (params.node.rowPinned && params.data.height) {
            return params.data.height;
          }
          return 20;
        },

        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        headerHeight: 50,
      },

      summaryInfo: {
        // 헤더 및 요약 정보 저장 객체
        monthlyGoalQty: null, // 월 목표 수량 (arrDailySaleData(7, 0))
        monthlyMaxGoalQty: null, // 당월최고수량 260420 추가
        dailyGoalQty: null, // 오늘 목표 수량 (arrDailySaleData(6, 0))
        monthlyGoalPoints: null, // 월 목표 점수 (arrDailySaleData(5, 0))
        dailyGoalPoints: null, // 오늘 목표 점수 (계산됨)
        personnelTO: null, // 근무 TO (오늘 데이터)
        personnelActual: null, // 근무 (오늘 데이터)
        todayMatch: null, // 오늘 적합도 (오늘 데이터)
        // totalQty: 0, // 총 판매수량 (계산됨)
        totalQty: null, // 당월수량 260420 추가
        totalPoints: 0, // 총 판매점수 (계산됨)
        totalMatch: 0, // 총 적합도 (계산됨)
        projectedQtySum: null, // 예상 월 수량 합계 (계산됨)
        projectedPointSum: null, // 예상 월 점수 합계 (계산됨)
        avgMatch: null, // 평균 적합도 (계산됨)
        currentDayOfMonth: new Date().getDate(), // 오늘 날짜 (일)
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
        ).getDate(), // 이 달의 마지막 날짜 (일)
      },
    };
  },
  created() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    const params = {};
    if (this.userInfo && this.userInfo.OGN_FG !== "00") {
      params.shopNm = this.userInfo.SHOP_NM;
    }

    // 초기 데이터 로드
    Promise.all([
      axios.get("/api/seListPage", { params }),
      axios.get("/api/seListPage/center"),
    ])
      .then(([response1, response2]) => {
        this.rowData1 = response1.data; // 점포 목록
        this.centerData = response2.data; // center 목록

        // Puppeteer에서 사용할 수 있도록 노출
        window.captureRowData = this.rowData1;

        if (this.centerData && this.centerData.length > 0) {
          this.selectedCenter = this.centerData[0]; // 기본값으로 첫 번째 본부 선택
        }
      })
      .catch((err) => {
        console.error(err);
      });
  },
  mounted() {
    // 매장 사용자인 경우 (OGN_FG !== '00') 바로 데이터 조회
    if (this.userInfo && this.userInfo.OGN_FG !== "00") {
      this.details(this.userInfo.SHOP_CD);
      this.storeTotMem(this.userInfo.SHOP_CD);
      this.monthSaleQtyData(this.userInfo.SHOP_CD);
      this.fetchConfirmations(this.userInfo.SHOP_CD);
      this.fetchShopComments(this.userInfo.SHOP_CD);
    }

    this.fetchIndexGoal();

    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getSelectedShopCd() {
      if (this.userInfo?.OGN_FG !== "00") {
        return this.userInfo?.SHOP_CD || "";
      }
      return this.selectedShop?.SHOP_CD || "";
    },

    updateContractRowsForEdit(yearLabel, monthKey, contractQty) {
      if (!Array.isArray(this.rowData2)) return;

      const numericQty = Number.isFinite(Number(contractQty))
        ? Number(contractQty)
        : 0;
      const yearRows = this.rowData2.filter((row) => row.year === yearLabel);
      if (!yearRows.length) return;

      const contractQtyRow = yearRows.find((row) => row.gubun === "계약수량");
      if (contractQtyRow) {
        contractQtyRow[monthKey] = numericQty;
      }

      const maxQtyRow = yearRows.find((row) => row.gubun === "최고수량");
      const contractDiffRow = yearRows.find((row) => row.gubun === "계약차이");
      if (contractDiffRow && maxQtyRow) {
        const maxQtyValue = Number(maxQtyRow[monthKey] || 0);
        contractDiffRow[monthKey] = numericQty - maxQtyValue;
      }

      const salesQtyRow = yearRows.find((row) => row.gubun === "판매수량");
      const contractSubtractionRow = yearRows.find((row) => row.gubun === "계약과부");
      if (contractSubtractionRow && salesQtyRow) {
        const salesQtyValue = Number(salesQtyRow[monthKey] || 0);
        contractSubtractionRow[monthKey] = salesQtyValue - numericQty;
      }

      ["계약수량", "계약차이", "계약과부"].forEach((gubun) => {
        const row = yearRows.find((item) => item.gubun === gubun);
        if (!row) return;

        let sum = 0;
        for (let m = 1; m <= 12; m++) {
          const key = `${m}month`;
          sum += Number(row[key] || 0);
        }
        row.totalCnt = sum;
      });
    },

    async onCellValueChanged(params) {
      // 사용자 권한 확인
      // if (this.userInfo?.OGN_FG !== "00") return;

      const { colDef, data, newValue, oldValue } = params;
      const gubun = data.gubun;
      // const editableGubuns = ["컨설턴트", "사업주명", "부점장명", "계약수량"];   //20260806 계약수량 수정 안되게
      const editableGubuns = ["컨설턴트", "사업주명", "부점장명", "목표수익"];    // 20260825 목표수익 추가

      // 수정된 행이 대상인지 확인
      if (!editableGubuns.includes(gubun)) return;

      // 값이 실제로 변경되었는지 확인
      if (newValue === oldValue) return;

      const year = data.year.substring(0, 4);
      const currentYear = new Date().getFullYear().toString();

      // 현재 연도 데이터만 저장
      if (year !== currentYear) return;

      const month = parseInt(colDef.field.replace("month", ""), 10);
      const saleMm = `${year}-${String(month).padStart(2, "0")}`;

      // 같은 월의 컨설턴트, 사업주명, 부점장명 값을 찾습니다.
      const yearData = this.rowData2.filter((row) => row.year === data.year);
      const ceoNm = (
        yearData.find((r) => r.gubun === "컨설턴트")?.[colDef.field] || ""
      ).trim();
      const masterNm = (
        yearData.find((r) => r.gubun === "사업주명")?.[colDef.field] || ""
      ).trim();
      const managerNm = (
        yearData.find((r) => r.gubun === "부점장명")?.[colDef.field] || ""
      ).trim();

      const payload = {
        shopCd: this.getSelectedShopCd(),
        saleMm: saleMm,
        shopCeoNm: ceoNm,
        shopMasterNm: masterNm,
        shopManagerNm: managerNm,
      };
      // 목표수익   20260825 추가
      if (params.data.gubun === "목표수익" && params.newValue?.length > 5) {
        alert("목표수익은 5자리까지만 입력 가능합니다");
        params.node.setDataValue(params.colDef.field, params.newValue.slice(0, 5));
      }

      try {
        //20260806 계약수량 수정 안되게
        // if (gubun === "계약수량") {
        //   const numericValue =
        //     newValue === null || newValue === "" || Number.isNaN(Number(newValue))
        //       ? 0
        //       : Number(newValue);
        // await axios.post("/api/seListPage/saveContractQuantity", {
        //   shopCd: this.getSelectedShopCd(),
        //   saleMm: saleMm.replace(/-/g, ""),
        //   contractQty: numericValue,
        //   userId: this.userInfo.userId,
        // });
        // this.updateContractRowsForEdit(data.year, colDef.field, numericValue);

        // 20260825 목표수익 추가
        if (gubun === "목표수익") {
          const numericValue =
            newValue === null || newValue === "" || Number.isNaN(Number(newValue))
              ? 0
              : Number(newValue);
          await axios.post("/api/seListPage/saveTargetProfit", {
            shopCd: this.getSelectedShopCd(),
            saleMm: saleMm.replace(/-/g, ""),
            contractQty: numericValue,
            userId: this.userInfo.userId,
          });

        } else {
          await axios.post("/api/seListPage/saveGuidance", payload);
        }
      } catch (error) {
        console.error("데이터 저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
        // 변경사항을 원상 복구
        params.node.setDataValue(colDef.field, oldValue);
      }
    },
    async fetchData(indexParam = "0", branchCd = "00") {
      this.selectedRowData = null; // 점포 목록을 새로고침할 때 선택된 행 데이터 초기화

      try {
        const params = { index: indexParam, branchCd: branchCd };
        if (this.userInfo && this.userInfo.OGN_FG !== "00") {
          params.shopNm = this.userInfo.SHOP_NM;
        }

        // if (this.gridApi1) this.gridApi1.showLoadingOverlay(); // 로딩 오버레이 표시
        const response = await axios.get(`/api/seListPage`, { params });

        this.rowData1 = response.data; // 반환된 데이터를 rowData에 저장
      } catch (error) {
        console.error("데이터 가져오기 오류:", error);
      }
    },

    refreshRightGrid(params) {
      // this.fetchData(params);
      this.fetchData(
        params,
        this.selectedCenter ? this.selectedCenter.BRANCH_CD : "00",
      );
    },

    onCenterChange() {
      // 선택된 본부의 BRANCH_CD를 사용하여 점포 목록 데이터 다시 가져오기
      // this.fetchData("0", this.selectedCenter.BRANCH_CD); // 기본 index "0"과 선택된 본부의 BRANCH_CD 사용

      if (this.selectedCenter && this.selectedCenter.BRANCH_CD) {
        // 특정 본부가 선택된 경우
        this.fetchData("0", this.selectedCenter.BRANCH_CD);

        const goalItems = this.indexGoalList.filter(
          (item) => item.BRANCH_CD === this.selectedCenter.BRANCH_CD,
        );
        const branchTotal = goalItems.reduce(
          (sum, d) => sum + (Number(d.LINDEXGOAL) || 0),
          0,
        );
        // Appheader.vue에 전달
        this.$emit("top-info-change", { indexGoal: branchTotal });
      } else {
        // "전체" (플레이스홀더) 옵션이 선택된 경우 (this.selectedCenter가 null)
        this.fetchData("0", "00"); // "00"은 전체 본부를 의미
      }

      if (this.selectedCenter.BRANCH_CD == "00") {
        const branchTotal = this.indexGoalList.reduce(
          (sum, d) => sum + (Number(d.LINDEXGOAL) || 0),
          0,
        );
        this.$emit("top-info-change", { indexGoal: branchTotal });
      }
    },

   onLeftGridReady(params) {
      this.leftGridApi = params.api;
    },
    onRightGridReady(params) {
      this.rightGridApi = params.api;
      // Puppeteer에서 사용
      window.rightGridApi = params.api;
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 20 : 15.5;
      const newGridHeight1 = isWide ? 20 : 14;
      // const newGridHeight2 = isWide ? 41.5 : 32.5;
      const newGridHeight2 = !this.useNewSeListGrid 
        ? (isWide ? 53 : 32.5) 
        : (isWide ? 37.7 : 32.5);
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.leftGridApi) this.leftGridApi.resetRowHeights();
        if (this.rightGridApi) this.rightGridApi.resetRowHeights();
      }
      if (
        this.gridHeight2 !== newGridHeight2 ||
        this.gridHeight1 !== newGridHeight1
      ) {
        this.gridHeight1 = newGridHeight1;
        this.gridHeight2 = newGridHeight2;
      }
    },

    onQuickFilterChanged(event) {
      const filterValue = event.target.value; // 입력 필드 값 가져오기
      if (this.rightGridApi) {
        this.rightGridApi.setGridOption("quickFilterText", filterValue); // quickFilter 적용
      } else {
        console.error("Grid API is not initialized.");
      }
    },
 
    async onCellClicked(event) {
      if (event.node) {
        event.node.setSelected(true); // 행(row)을 선택

        const selectedShop = event.node.data; // 선택된 행의 SHOP_CD 가져오기
        this.selectedShop = {
          VAN_BIZ_NO: selectedShop.VAN_BIZ_NO,
          SHOP_CD: selectedShop.SHOP_CD,
          SHOP_NM: selectedShop.SHOP_NM,
          TEL_NO: selectedShop.TEL_NO,
        };

        const goalItem = this.indexGoalList.find(
          (item) => (item.SHOP_CD || item.shop_cd) === selectedShop.SHOP_CD,
        );
        const goalValue = goalItem ? goalItem.LINDEXGOAL : 0;
        // Appheader.vue에 전달
        this.$emit("top-info-change", {
          shopName: event.data.SHOP_NM,
          telNo: event.data.TEL_NO,
          indexGoal: goalValue,
        });

        this.$emit("reset-grid-view");

        await Promise.all([
          this.details(selectedShop.SHOP_CD),
          this.storeTotMem(selectedShop.SHOP_CD),
          this.monthSaleQtyData(selectedShop.SHOP_CD),
          this.fetchConfirmations(selectedShop.SHOP_CD),
          this.fetchShopComments(selectedShop.SHOP_CD),
        ]);

        this.selectedRowData = [event.data]; // 선택된 행의 데이터 저장

        await this.$nextTick();

        // 화면을 한 번 더 그리도록 대기
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
              window.captureComplete = true;
          });
        });
      }
    },

    // 우클릭 event 처리: ag-grid의 cell-context-menu 이벤트 사용
    async onCellContextMenu(params) {
      // 브라우저의 기본 컨텍스트 메뉴가 나타나지 않도록 항상 가장 먼저 호출
      if (params.event) {
        params.event.preventDefault();
      }
      // params: { event, node, data, column, rowIndex, columnApi, api }
      // const field = params.colDef?.field || params.column?.getColId?.();
      // const row = params.node?.rowIndex;
      const data = params.data || {};

      // 감사팀 권한이면 감사 패널 열기
      if (
        this.userInfo &&
        ["감사팀", "관리자팀", "판매전쟁실"].includes(this.userInfo.EMP_DEPT_NM)
      ) {
        const shopCd = data.SHOP_CD || "";
        this.auditShopCd = shopCd;
        this.auditShopNm = data.SHOP_NM || "";
        // 기본 날짜는 오늘(YYYY-MM-DD)로 설정하되, 이미 사용자가 선택한 값이 있으면 유지
        this.auditDate = this.auditDate || new Date().toLocaleDateString("sv"); // YYYY-MM-DD
        await this.loadAudit(shopCd, this.auditDate);
        this.showAuditmodal = true;
        return;
      }

      // 이제 사용 안하는 기능 만들려다 안함
      // 특정 사용자(관리자 목록) 이고 Col이 점번 또는 점명이면 TYPE 변경 토글 로직
      /*if (this.userInfo && ["관리자","이도건","김완수","김윤동"].includes(this.userInfo.EMP_NM) && (field === "VAN_BIZ_NO" || field === "SHOP_NM") && row >= 0) {
        // vTYPE 컬럼을 찾아서 값을 읽음 (여러 프로젝트마다 컬럼명 다름 => fallback)
        const typeFieldCandidates = ["TYPE","TYPE_FG","VTYPE","STORE_TYPE","STORE_KIND","TRBIZ_TYPE"];
        let vTYPE = null;
        for (const f of typeFieldCandidates) {
          if (data[f] !== undefined) { vTYPE = data[f]; break; }
        }
        // 컬럼에 따라 동작: 점번(Col 1)일 때  -> set 3
        if (field === "VAN_BIZ_NO" && Number(vTYPE) !== 3) {
          await this.updateStoreType(3, data);
        } else if (field === "SHOP_NM") {
          // SHOP_NM 우클릭은 같이 토글 (원본 VB: Col=2 토글 0/1/2)
          const cur = Number(vTYPE) || 0;
          if (cur === 0) await this.updateStoreType(1, data);
          else if (cur === 1) await this.updateStoreType(2, data);
          else await this.updateStoreType(0, data);
        }
      }*/
    },

    async loadAudit(shopCd, date = null) {
      try {
        const params = { shopCd: shopCd };
        if (date) params.date = date; // YYYY-MM-DD
        const res = await axios.get("/api/seListPage/audit", { params });
        this.auditList =
          Array.isArray(res.data) && res.data.length
            ? res.data.map((r) => ({
                lId: r.lID,
                date: r.AUDIT_DATE,
                person: r.AUDITOR || r.PERSON || "",
                kind: r.ITEM || "",
                score: r.SCORE || "",
              }))
            : [];
      } catch (err) {
        console.error("loadAudit error:", err);
        this.auditList = [];
      }
    },

    async addAudit() {
      try {
        if (!this.auditShopCd) {
          alert("대상 매장이 선택되지 않았습니다.");
          return;
        }
        if (!this.auditKind) {
          alert("구분을 선택해주세요.");
          return;
        }
        if (this.auditKind == "감사") {
          if (!this.auditScore) {
            alert("점수를 입력해 주세요.");
            return;
          }
        }
        const payload = {
          shopCd: this.auditShopCd,
          date: this.auditDate,
          userId: this.userInfo.userId,
          kind: this.auditKind,
          score: this.auditScore,
        };
        // 실제 백엔드 엔드포인트에 맞게 수정
        await axios.post("/api/seListPage/auditAdd", payload);

        await this.loadAudit(this.auditShopCd, this.auditDate);
        this.auditDate = new Date().toLocaleDateString("sv");
        this.auditKind = "해지";
        this.auditScore = "";
      } catch (err) {
        console.error("addAudit error:", err);
        alert("일정 추가 중 오류가 발생했습니다.");
      }
    },
    async removeAuditRow(idx) {
      const itemToDelete = this.auditList[idx];
      if (!itemToDelete || !itemToDelete.lId) {
        // lId가 없는 경우 (아직 저장되지 않은 행)는 UI에서만 제거
        this.auditList.splice(idx, 1);
        return;
      }

      if (confirm("선택한 항목을 삭제하시겠습니까?")) {
        try {
          await axios.post("/api/seListPage/deleteAudit", {
            lId: itemToDelete.lId,
            userId: this.userInfo.userId,
          });
          await this.loadAudit(this.auditShopCd, this.auditDate);
        } catch (error) {
          console.error("감사 기록 삭제 실패:", error);
          alert("삭제 처리 중 오류가 발생했습니다.");
        }
      }
    },

    closeAuditmodal() {
      this.showAuditmodal = false;
      this.auditList = [];
      this.auditShopCd = "";
      this.auditShopNm = "";
      this.auditDate = new Date().toLocaleDateString("sv");
      this.auditKind = "해지";
      this.auditScore = "";
    },

    // 이제 사용 안하는 기능 만들려다 안함
    // 서버에 타입 변경 요청 및 그리드 반영
    /* async updateStoreType(typeValue, rowData) {
      try {
        const store = rowData.SHOP_CD || rowData.VAN_BIZ_NO || rowData.SHOP_NO;
        await axios.post("/api/seListPage/storeType", { shop: store, type: typeValue });
        // 그리드 데이터 갱신: 로컬로 값 변경 후 refresh
        // const rowNode = this.gridApi1?.getRowNode?.(rowData.__rowId || rowData.id) || null;
        // 안전하게 rowData 직접 변경하여 grid 갱신
        const idx = this.rowData1.findIndex(r => (r.SHOP_CD||r.VAN_BIZ_NO||r.SHOP_NO) === store);
        if (idx >= 0) {
          // 가능한 필드 이름들에 대해 업데이트
          const setFields = ["TYPE","TYPE_FG","VTYPE","STORE_TYPE","TRBIZ_TYPE"];
          for (const f of setFields) {
            if (this.rowData1[idx][f] !== undefined) {
              this.$set(this.rowData1[idx], f, typeValue);
              break;
            }
          }
          // 강제 렌더링
          if (this.gridApi1) {
            this.gridApi1.setRowData(this.rowData1);
          }
        }
      } catch (err) {
        console.error("updateStoreType error:", err);
      }
    },*/

    async fetchIndexGoal() {
      try {
        const res = await axios.get("/api/seListPage/indexGoal");
        this.indexGoalList = res.data || [];
        const total = this.indexGoalList.reduce(
          (sum, d) => sum + (Number(d.LINDEXGOAL) || 0),
          0,
        );
        const payload = { indexGoal: total };
        if (this.userInfo) {
          if (this.userInfo.OGN_FG === "00") {
            payload.shopName = "본사로그인";
          } else {
            payload.shopName = this.userInfo.SHOP_NM;
            payload.telNo = this.userInfo.TEL_NO;

            const goalItem = this.indexGoalList.find(
              (item) => item.SHOP_CD === this.userInfo.SHOP_CD,
            );
            const goalValue = goalItem ? goalItem.LINDEXGOAL : 0;
            payload.indexGoal = goalValue;
          }
          this.$emit("top-info-change", payload);
        }
      } catch (error) {
        console.error("Index Goal fetch failed:", error);
      }
    },

    async details(shopCd) {
      try {
        if (this.userInfo && this.userInfo.OGN_FG === "01") {
          shopCd = this.userInfo.SHOP_CD;
        }

        const response = await axios.get(
          `/api/seListPage/details?shopCd=${shopCd}`,
        );
        // const data = response.data;
        const { finalData } = response.data;

        // 응답 데이터가 배열인지 확인
        // setTimeout(() => {
          this.rowData2 = this.transformData(finalData);
          this.warningFlag = response.data.warningFlag;
          
        // }, 0);
        
        // Vue가 Grid를 다시 그릴 때까지 기다림
        await this.$nextTick();

        window.lastDetailShopCd = shopCd;

      } catch (error) {
        console.error("데이터 조회 오류:", error);
      }
    },

    async detailsQty(shopCd) {
      try {
        if (this.userInfo && this.userInfo.OGN_FG === "01") {
          shopCd = this.userInfo.SHOP_CD;
        }

        const params = { shopCd: shopCd };
        if (this.useNewSeListGrid) {
          params.mode = 'operation';
        }

        const response = await axios.get(
          `/api/seListPage/detailsQty?shopCd=${shopCd}`,
        );
        const data = response.data;

        // 응답 데이터가 배열인지 확인
        setTimeout(() => {
          this.rowData2 = this.transformQtyData(data);
        }, 0);
      } catch (error) {
        console.error("데이터 조회 오류:", error);
      }
    },

    async storeTotMem(shopCd) {
      try {
        const currentDate = new Date();
        const currentYearMonth = `${currentDate.getFullYear()}-${String(
          currentDate.getMonth() + 1,
        ).padStart(2, "0")}`; // 현재 연도와 월을 "YYYY-MM" 형식으로 조합

        const response = await axios.get(
          `/api/seListPage/storeTotMem?year=${currentYearMonth}&shopCd=${shopCd}`,
        );
        const data = response.data;

        this.totalCustomers = Number(data.CST_TOT_CNT) || 0; // 총고객수
        this.availableCustomers = Number(data.DIFFERENCE) || 0; // 가용 고객수
      } catch (error) {
        console.error("추가 데이터 가져오기 오류:", error);
      }
    },

    calculateRowSpan(params) {
      if (!params.data || !params.data.year) return 1;
      const year = params.data.year;
      const rowIndex = params.node.rowIndex;

      // 이전 행과 값이 같으면 1 반환 (병합된 셀의 일부로 처리됨)
      if (rowIndex > 0) {
        const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
        if (prevNode && prevNode.data && prevNode.data.year === year) {
          return 1;
        }
      }

      // 이후 행들과 값이 같은지 확인하여 병합할 행 수 계산
      let count = 1;
      let nextIndex = rowIndex + 1;
      let nextNode = params.api.getDisplayedRowAtIndex(nextIndex);

     while (nextNode && nextNode.data && nextNode.data.year === year) {
      count++;
      nextIndex++;
      nextNode = params.api.getDisplayedRowAtIndex(nextIndex);
      }
      return count;

    },

    transformData(data) {
      const transformed = {};
      const currentYear = new Date().getFullYear(); // 현재 연도

      // 최고 판매수량 계산
      const maxSaleQtyByMonth = {};

      if (!Array.isArray(data)) {
        console.error("transformData: 입력 데이터가 배열이 아닙니다.", data);
        return [];
      }

      data.forEach((row) => {
        if (!row || !row.SALE_MM) {
          // 문제가 있는 데이터 건너뛰기
          return; // 현재 반복 건너뛰고 다음 row 처리
        }

        const year = parseInt(row.SALE_MM.substring(0, 4)); // 년도 추출
        const month = parseInt(row.SALE_MM.substring(4, 6)); // 월 추출
        // const yearYY = year.toString().substring(2, 4); // 연도 YY 추출

        // 월별 최고 판매수량 계산
        if (year <= currentYear - 1) {
          if (
            !maxSaleQtyByMonth[month] ||
            maxSaleQtyByMonth[month] < parseInt(row.SALE_QTY)
          ) {
            maxSaleQtyByMonth[month] = parseInt(row.SALE_QTY);
          }
        }
        if (!transformed[year]) {
          if (year === currentYear) {
            transformed[year] = {
              // 회장님 지시사항 반영 으로  컨설턴트,부점장명 제거
              // manageGuid: { year: `${year}년`, gubun: "컨설턴트" },
              // branchManager: { year: `${year}년`, gubun: "부점장명" },
              ownerName: { year: `${year}년`, gubun: "사업주명" },          //0
              suretyEd: { year: `${year}년`, gubun: "계약일" },             //1
              plannedAmount: { year: `${year}년`, gubun: "연간약정" },      //2
              appliedRate: { year: `${year}년`, gubun: "적용률" },          //3
              actualAmount: { year: `${year}년`, gubun: "월별약정" },       //4
              amountDiff: { year: `${year}년`, gubun: "차액" },             //5
              maxQty: { year: `${year}년`, gubun: "최고수량" },             //6
              salesQty: { year: `${year}년`, gubun: "판매수량" },           //7
              qtyDiff: { year: `${year}년`, gubun: "수량차이" },            //8
              averaScore: { year: `${year}년`, gubun: "평균점수" },         //9
              salesRevenue: { year: `${year}년`, gubun: "매출액" },         //10
              unitPrice: { year: `${year}년`, gubun: "판가" },              //11
              commissionAmt: { year: `${year}년`, gubun: "수수료" },        //12
              ownerAmount: { year: `${year}년`, gubun: "업주부담" },        //13
              netAmount: { year: `${year}년`, gubun: "상계차액" },          //14
              comPreFeeTotal: { year: `${year}년`, gubun: "받은금액" },     //15
              comPreFinalDiff: { year: `${year}년`, gubun: "보증증감" },    //16
              comPreFeeFinal2: { year: `${year}년`, gubun: "월말보증" },    //17
              saleAmount: { year: `${year}년`, gubun: "지출예측" },         //18
              diffAmount: { year: `${year}년`, gubun: "증감예측" },         //19
              depositAmount: { year: `${year}년`, gubun: "보증예측" },      //20
              commissionRate: { year: `${year}년`, gubun: "수수료율" },     //21
              netFeeRate: { year: `${year}년`, gubun: "상후수율" },         //22
              toCnt: { year: `${year}년`, gubun: "필수인원" },              //23 //261016수정 필수고용->필수인원
              teamStaffCnt: { year: `${year}년`, gubun: "현인원" },         //24
              toDiff: { year: `${year}년`, gubun: "인원과부" },             //25 //261016수정 고용과부->인원과부
              inventoryQuantity: { year: `${year}년`, gubun: "재고수량" },  //26
              carryoverQuantity: { year: `${year}년`, gubun: "이월수량" },  //27
              carryoverRate: { year: `${year}년`, gubun: "이월비율" },      //28
              totalCustomers: { year: `${year}년`, gubun: "총고객수" },     //29
              customersIncrease: { year: `${year}년`, gubun: "고객증감" },  //30
              filterQty: { year: `${year}년`, gubun: "필터판매" },          //31
              filterRate: { year: `${year}년`, gubun: "필터비율" },         //32
              wipersQty: { year: `${year}년`, gubun: "윈도판매" },          //33
              wipersRate: { year: `${year}년`, gubun: "윈도비율" },         //34
              costEmploy: { year: `${year}년`, gubun: "직원급계" },      //35
              estimatedIncome: { year: `${year}년`, gubun: "추정손익" },    //36
              totalProfit: { year: `${year}년`, gubun: "추정총액" },        //37
              totalShopCnt: { year: `${year}년`, gubun: "점포수" },         //38
              ownerAverage: { year: `${year}년`, gubun: "업주평균" },       //39
              auditDate: { year: `${year}년`, gubun: "감사일자" },          //40

              // contractRate: { year: `${year}년`, gubun: "계약달률" },            //9
              // guaranteedPayment: { year: `${year}년`, gubun: "보증납부" },      //21
              // guaranteedBalance: { year: `${year}년`, gubun: "보증잔액" },      //21

              // (업주부담, 상계차액, 상후수율) 20260728 제거 -> 20260820 다시 삽입

              // 20260820 제거
              // contractQuantity: { year: `${year}년`, gubun: "계약수량" },   //9
              // contractDiff: { year: `${year}년`, gubun: "계약차이" },       //10
              // contractRate: { year: `${year}년`, gubun: "계약달률" },       //11
            };
          } 
          // else if (year === currentYear - 1) {
          //   transformed[year] = {
          //     ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
          //     salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
          //     qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
          //     // averaScore: { year: `${yearYY}년`, gubun: "평균점수" },
          //     auditDate: { year: `${yearYY}년`, gubun: "감사일자" },
          //   };
          // } else {
          //   transformed[year] = {
          //     ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
          //     salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
          //     qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
          //   };
          // }
        }

        // 하위 객체 초기화 확인
        // if (!transformed[year].salesQty) {
        //   transformed[year].salesQty = {};
        // }
        // if (!transformed[year].qtyDiff) {
        //   transformed[year].qtyDiff = {};
        // }

        // 사업주명 추가
        // transformed[year].ownerName[`${month}month`] = row.SHOP_MASTER_NM || "";

        // 판매수량 추가
        // transformed[year].salesQty[`${month}month`] = Math.round(row.SALE_QTY);
        // if (row.SALE_QTY != null ) {
        //   transformed[year].salesQty[`${month}month`] = Math.round(
        //     row.SALE_QTY,
        //   );
        // }

        // if (year <= currentYear - 2) {
        //   // 현재 연도 - 5년의 값은 "GAP"으로 설정
        //   transformed[year].qtyDiff[`${month}month`] = row.GAP;
        // }

        // if (year >= currentYear - 1) {
        //   transformed[year].auditDate[`${month}month`] = row.AUDIT_DATE ?? "";
          // transformed[year].averaScore[`${month}month`] = Math.round(
          //   row.SALE_SCORE_AVG,
          // );
        // if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
        //     transformed[year].averaScore[`${month}month`] = Math.round(
        //       row.SALE_SCORE_AVG,
        //     );
        //   }
        // }


        if (year === currentYear) {
          // 회장님 지시사항 반영 20260204 컨설턴트, 부점장 제거 
          // transformed[year].manageGuid[`${month}month`] = row.SHOP_CEO_NM || "";
          // transformed[year].branchManager[`${month}month`] = row.SHOP_MANAGER_NM || "";
          // transformed[year].averaScore[`${month}month`] = Math.round(
          //   row.SALE_SCORE_AVG,
          // );

        // transformed[year].guaranteedPayment[`1month`] = '10000';
        // transformed[year].guaranteedPayment[`2month`] = '10000';
        // transformed[year].guaranteedPayment[`3month`] = '10000';
        // transformed[year].guaranteedPayment[`4month`] = '10000';
        // transformed[year].guaranteedPayment[`5month`] = '10000';

        // transformed[year].guaranteedBalance[`1month`] = '3261';
        // transformed[year].guaranteedBalance[`2month`] = '3561';
        // transformed[year].guaranteedBalance[`3month`] = '3861';
        // transformed[year].guaranteedBalance[`4month`] = '4161';
        // transformed[year].guaranteedBalance[`5month`] = '4461';

          transformed[year].ownerName[`${month}month`] = row.SHOP_MASTER_NM || "";
          if (row.SALE_QTY != null ) {
            transformed[year].salesQty[`${month}month`] = Math.round(row.SALE_QTY,);
          }

          if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
            transformed[year].averaScore[`${month}month`] = Math.round(
              row.SALE_SCORE_AVG,
            );
          }
          // 20260724 계약수량 추가   //20260806 계약차이 수정
          // const contractQtyValue = Number(row.CONTRACT_QTY ?? 0);
          // if (contractQtyValue > 0 || row.CONTRACT_QTY !== undefined) {
          //   transformed[year].contractQuantity[`${month}month`] = contractQtyValue;
          // }
          // if (row.SALE_QTY != null && !isNaN(row.SALE_QTY)) {
          //   const saleQtyValue = Math.round(row.SALE_QTY);
          //   const contractQtyValue = Number(row.CONTRACT_QTY ?? 0);
          //   // SALE_QTY가 있을 때만 contractDiff 계산
          //   transformed[year].contractDiff[`${month}month`] = saleQtyValue - contractQtyValue;
          // }

          // 계약달률 (계약수량 ÷ 기준수량 × 100)
          // const salesQtyValue = transformed[year].salesQty?.[`${month}month`] || 0;
          // if (salesQtyValue > 0 && contractQtyValue > 0) {
          //   transformed[year].contractRate[`${month}month`] =
          //     ((salesQtyValue / contractQtyValue) * 100).toFixed(1) + "%";
          // } else {
          //   transformed[year].contractRate[`${month}month`] = ""; // 판매수량 없거나 계약수량이 0이면 빈값
          // }

          transformed[year].suretyEd[`${month}month`] = row.SURETY_ED;
          transformed[year].plannedAmount[`${month}month`] = row.PLAN_AMOUNT;
          transformed[year].appliedRate[`${month}month`] = row.APPLIED_RATE != null ? row.APPLIED_RATE + "%" : "";
          // transformed[year].actualAmount[`${month}month`] = row.ACTUAL_AMOUNT;
          transformed[year].actualAmount[`${month}month`] = row.PLAN_AMOUNT && row.APPLIED_RATE
            ? Math.round(row.PLAN_AMOUNT * (row.APPLIED_RATE / 100))
            : "";
          transformed[year].amountDiff[`${month}month`] = row.AMOUNT_DIFF;

          transformed[year].salesRevenue[`${month}month`] = row.DCM_SALE_AMT;
          transformed[year].unitPrice[`${month}month`] = row.UNIT_PRICE ?? "";
          transformed[year].commissionAmt[`${month}month`] = row.COMMISSION_AMT;
          transformed[year].ownerAmount[`${month}month`] = row.OWNER_AMOUNT;
          if(row.COMMISSION_AMT != null && row.OWNER_AMOUNT != null){
            transformed[year].netAmount[`${month}month`] = row.COMMISSION_AMT - row.OWNER_AMOUNT;
          }
          transformed[year].comPreFeeTotal[`${month}month`] = row.COM_PRE_FEE_TOTAL;
          transformed[year].comPreFinalDiff[`${month}month`] = row.COM_PRE_FINAL_DIFF ?? "";
          transformed[year].comPreFeeFinal2[`${month}month`] = row.COM_PRE_FINAL_2 ?? "";
          transformed[year].saleAmount[`${month}month`] =  row.SALE_AMOUNT == 0 ? "" : row.SALE_AMOUNT ?? "";
          transformed[year].diffAmount[`${month}month`] = row.DIFF_CAL_DATA_2 ?? "";
          // transformed[year].diffAmount[`${month}month`] = 
          //   (transformed[year].saleAmount[`${month}month`] !=="" && transformed[year].netAmount[`${month}month`] !== "" )
          //     ? (transformed[year].netAmount[`${month}month`] - transformed[year].saleAmount[`${month}month`]) : "";
          transformed[year].depositAmount[`${month}month`] = row.LASTPROFIT;
          // transformed[year].guaranteedPayment[`${month}month`] = '10000';
          // transformed[year].guaranteedBalance[`${month}month`] = '5000';
          transformed[year].commissionRate[`${month}month`] = 
            (row.COMMISSION_AMT != null && row.DCM_SALE_AMT) ? (row.COMMISSION_AMT/row.DCM_SALE_AMT * 100).toFixed(1) + "%" : "";
          transformed[year].netFeeRate[`${month}month`] = 
            (row.COMMISSION_AMT != null && row.DCM_SALE_AMT) ? 
              (((row.COMMISSION_AMT - row.OWNER_AMOUNT) / row.DCM_SALE_AMT) * 100).toFixed(1) + "%" : "";
          
          transformed[year].toCnt[`${month}month`] = row.TO_CNT;
          transformed[year].teamStaffCnt[`${month}month`] = row.TEAM_STAFF_CNT;
          transformed[year].toDiff[`${month}month`] = row.TO_DIFF

          transformed[year].inventoryQuantity[`${month}month`] = row.CLOSE_QTY;
          transformed[year].carryoverQuantity[`${month}month`] = row.CLOSE_CVR_QTY;
          transformed[year].carryoverRate[`${month}month`] = row.CARRYOVER_RATE != null ? row.CARRYOVER_RATE + "%" : "";
          transformed[year].totalCustomers[`${month}month`] = row.TOT_CNT ?? "";
          transformed[year].customersIncrease[`${month}month`] = row.MONTH_CNT ?? "";
          transformed[year].filterQty[`${month}month`] = row.FILTER_QTY ?? "";
          transformed[year].filterRate[`${month}month`] = row.FILTER_RATE != null ? row.FILTER_RATE + "%" : "";
          transformed[year].wipersQty[`${month}month`] = row.WIPER_QTY ?? "";
          transformed[year].wipersRate[`${month}month`] = row.WIPER_RATE != null ? row.WIPER_RATE + "%" : "";
          transformed[year].costEmploy[`${month}month`] = row.COST_EMPLOY ?? "";
          // 추정손익 = 14상계차액 - 고용비용(평균고용수 *400 *1.35) - 타이어수량비용(7판매수량 *2000) - 부가세비용(14상계차액 * 0.1)
          const value = 
            (row.COMMISSION_AMT - row.OWNER_AMOUNT)
            - row.COST_EMPLOY
            - Math.round((row.SALE_QTY * 2000) / 10000)
            - Math.round((row.COMMISSION_AMT - row.OWNER_AMOUNT) * 0.1);
          transformed[year].estimatedIncome[`${month}month`] = isNaN(value) ? "" : value;
          transformed[year].totalProfit[`${month}month`] = row.TOTAL_PROFIT ?? "";
          transformed[year].totalShopCnt[`${month}month`] = row.TOTAL_SHOP_CNT ?? "";
          transformed[year].ownerAverage[`${month}month`] = row.OWNER_AVERAGE ?? "";
          transformed[year].auditDate[`${month}month`] = row.AUDIT_DATE ?? "";
        }
      });

      // 특정 연도와 월 키에 대한 판매 수량
      // const getQty = (transformed, year, monthKey) => {
      //   // 옵셔널 체이닝을 사용하여 중첩된 속성에 안전하게 접근
      //   return parseInt(transformed[year]?.salesQty?.[monthKey] || 0);
      // };

      // --- 수량 차이(qtyDiff) 및 최고 수량(maxQty) 계산 ---
      // Object.keys(transformed).forEach((yearStr) => {
      //   const numYear = parseInt(yearStr); // 문자열 연도를 숫자로 변환
      //   const salesQtyRow = transformed[yearStr]?.salesQty; // salesQty 행을 가져옴

      //   // --- 수량 차이(qtyDiff) 계산 ---
      //   if (
      //     salesQtyRow &&
      //     numYear >= currentYear - 5 &&
      //     numYear <= currentYear
      //   ) {
      //     // qtyDiff가 계산되는 연도에 대해 qtyDiff 객체가 존재하는지 확인하고 없으면 생성
      //     if (numYear >= currentYear - 3 && !transformed[yearStr].qtyDiff) {
      //       transformed[yearStr].qtyDiff = {
      //         year: yearStr.substring(2, 4),
      //         gubun: "수량차이",
      //       };
      //     }

      //     // salesQtyRow에 있는 월 키들을 순회
      //     Object.keys(salesQtyRow).forEach((key) => {
      //       // 실제 월 키('1month', '12month' 등)만 처리
      //       if (key.endsWith("month")) {
      //         const currentSaleQty = parseInt(salesQtyRow[key]) || 0; // 현재 월의 판매 수량
      //         const monthKey = key; // key는 이미 'Nmonth' 형식임

      //         let maxSaleQty = 0; // 해당 월의 이전 연도들 중 최고 판매 수량
      //         let diff = 0; // 수량 차이

      //         // 연도에 따라 특정 차이 계산 로직 적용 (원본 코드와 동일)
      //         if (numYear === currentYear - 3) {
      //           // -3년차: 이전 3개년 (currentYear-5, currentYear-4, currentYear-3) 중 최고값 계산
      //           maxSaleQty = Math.max(
      //             getQty(transformed, currentYear - 5, monthKey),
      //             getQty(transformed, currentYear - 4, monthKey),
      //             getQty(transformed, currentYear - 3, monthKey),
      //           );
      //           diff = currentSaleQty - maxSaleQty;
      //           // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
      //           if (diff === 0) {
      //             const nextMaxSaleQty = Math.max(
      //               getQty(transformed, currentYear - 5, monthKey),
      //               getQty(transformed, currentYear - 4, monthKey),
      //             );
      //             diff = currentSaleQty - nextMaxSaleQty;
      //           }
      //           transformed[yearStr].qtyDiff[monthKey] = diff;
      //         } else if (numYear === currentYear - 2) {
      //           // -2년차: 이전 4개년 중 최고값 계산
      //           maxSaleQty = Math.max(
      //             getQty(transformed, currentYear - 5, monthKey),
      //             getQty(transformed, currentYear - 4, monthKey),
      //             getQty(transformed, currentYear - 3, monthKey),
      //             getQty(transformed, currentYear - 2, monthKey),
      //           );
      //           diff = currentSaleQty - maxSaleQty;
      //           // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
      //           if (diff === 0) {
      //             const nextMaxSaleQty = Math.max(
      //               getQty(transformed, currentYear - 5, monthKey),
      //               getQty(transformed, currentYear - 4, monthKey),
      //               getQty(transformed, currentYear - 3, monthKey),
      //             );
      //             diff = currentSaleQty - nextMaxSaleQty;
      //           }
      //           transformed[yearStr].qtyDiff[monthKey] = diff;
      //         } else if (numYear === currentYear - 1) {
      //           // -1년차: 이전 5개년 중 최고값 계산
      //           maxSaleQty = Math.max(
      //             getQty(transformed, currentYear - 5, monthKey),
      //             getQty(transformed, currentYear - 4, monthKey),
      //             getQty(transformed, currentYear - 3, monthKey),
      //             getQty(transformed, currentYear - 2, monthKey),
      //             getQty(transformed, currentYear - 1, monthKey),
      //           );
      //           diff = currentSaleQty - maxSaleQty;
      //           // 차이가 0일 경우, 자신을 제외한 이전 연도들 중 최고값과 비교
      //           if (diff === 0) {
      //             const nextMaxSaleQty = Math.max(
      //               getQty(transformed, currentYear - 5, monthKey),
      //               getQty(transformed, currentYear - 4, monthKey),
      //               getQty(transformed, currentYear - 3, monthKey),
      //               getQty(transformed, currentYear - 2, monthKey),
      //             );
      //             diff = currentSaleQty - nextMaxSaleQty;
      //           }
      //           transformed[yearStr].qtyDiff[monthKey] = diff;
      //         } else if (numYear === currentYear) {
      //           // 현재 연도: 이전 5개년 중 최고값 계산
      //           maxSaleQty = Math.max(
      //             getQty(transformed, currentYear - 5, monthKey),
      //             getQty(transformed, currentYear - 4, monthKey),
      //             getQty(transformed, currentYear - 3, monthKey),
      //             getQty(transformed, currentYear - 2, monthKey),
      //             getQty(transformed, currentYear - 1, monthKey),
      //           );
      //           // 현재 연도는 diff === 0 케이스 처리가 원본 로직에 없음
      //           diff = currentSaleQty - maxSaleQty;
      //           transformed[yearStr].qtyDiff[monthKey] = diff;
      //         }
      //         // 참고: currentYear - 4년 이하의 연도에 대해서는 여기서 qtyDiff가 계산되지 않음
      //         // DB에서 이전에 설정된 'GAP' 값을 유지
      //       }
      //     });
      //   }

      //   // --- *현재* 연도의 최고 수량(maxQty) 행 계산 ---
      //   if (numYear === currentYear) {
      //     // 현재 연도에 maxQty 객체가 존재하는지 확인하고 없으면 생성
      //     if (!transformed[yearStr].maxQty) {
      //       transformed[yearStr].maxQty = {
      //         year: yearStr.substring(2, 4),
      //         gubun: "최고수량",
      //       };
      //     }

      //     let totalMaxSaleQty = 0; // 월별 최고 수량의 총합을 저장할 변수
      //     for (let m = 1; m <= 12; m++) {
      //       const monthKey = `${m}month`;
      //       // 해당 월에 대해 이전 5개년 간의 최고 판매 수량 계산
      //       const monthlyMax = Math.max(
      //         getQty(transformed, currentYear - 5, monthKey),
      //         getQty(transformed, currentYear - 4, monthKey),
      //         getQty(transformed, currentYear - 3, monthKey),
      //         getQty(transformed, currentYear - 2, monthKey),
      //         getQty(transformed, currentYear - 1, monthKey),
      //       );
      //       // 계산된 월별 최고 수량을 현재 연도의 maxQty 행에 할당
      //       transformed[yearStr].maxQty[monthKey] = monthlyMax;
      //       totalMaxSaleQty += monthlyMax; // 총합 누적
      //     }
      //     // 계산된 총합을 'totalCnt' 필드에 할당
      //     transformed[yearStr].maxQty["totalCnt"] = totalMaxSaleQty;
      //   }
      // });
      Object.keys(transformed).forEach((yearStr) => {
        const numYear = parseInt(yearStr); // 문자열 연도를 숫자로 변환
        const salesQtyRow = transformed[yearStr]?.salesQty; // salesQty 행을 가져옴



        // --- 수량 차이(qtyDiff) 계산 ---
        if (
          salesQtyRow &&
          numYear >= currentYear - 8 &&
          numYear <= currentYear
        ) {

          // salesQtyRow에 있는 월 키들을 순회
          Object.keys(salesQtyRow).forEach((key) => {
            // 실제 월 키('1month', '12month' 등)만 처리
            if (key.endsWith("month")) {
              const currentSaleQty = parseInt(salesQtyRow[key]) || 0; // 현재 월의 판매 수량
              const month = parseInt(key.replace("month", "")); // 월 추출
              const monthKey = key; // key는 이미 'Nmonth' 형식임

              let maxSaleQty = 0; // 해당 월의 이전 연도들 중 최고 판매 수량
              let diff = 0; // 수량 차이

              // 연도에 따라 특정 차이 계산 로직 적용 (원본 코드와 동일)
              if (numYear <= currentYear) {
                // 현재 연도: 이전 5개년 중 최고값 계산
                // maxSaleQty = Math.max(
                //   getQty(transformed, currentYear - 8, monthKey),
                //   getQty(transformed, currentYear - 7, monthKey),
                //   getQty(transformed, currentYear - 6, monthKey),
                //   getQty(transformed, currentYear - 5, monthKey),
                //   getQty(transformed, currentYear - 4, monthKey),
                //   getQty(transformed, currentYear - 3, monthKey),
                //   getQty(transformed, currentYear - 2, monthKey),
                //   getQty(transformed, currentYear - 1, monthKey),
                // );
                maxSaleQty = maxSaleQtyByMonth[month] || 0;
                // 현재 연도는 diff === 0 케이스 처리가 원본 로직에 없음
                diff = currentSaleQty - maxSaleQty;
                transformed[yearStr].qtyDiff[monthKey] = diff;
              }
              // 참고: currentYear - 4년 이하의 연도에 대해서는 여기서 qtyDiff가 계산되지 않음
              // DB에서 이전에 설정된 'GAP' 값을 유지
            }
          });
        }

        // --- *현재* 연도의 최고 수량(maxQty) 행 계산 ---
        if (numYear === currentYear) {
          // 현재 연도에 maxQty 객체가 존재하는지 확인하고 없으면 생성
          if (!transformed[yearStr].maxQty) {
            transformed[yearStr].maxQty = {
              year: yearStr.substring(2, 4),
              gubun: "최고수량",
            };
          }

          let totalMaxSaleQty = 0; // 월별 최고 수량의 총합을 저장할 변수
          const currentMonthNow = new Date().getMonth() + 1; // 현재 월 (1~12)
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            // 해당 월에 대해 이전 8개년 간의 최고 판매 수량 계산
            
            // 계산된 월별 최고 수량을 현재 연도의 maxQty 행에 할당
            const monthlyMax = maxSaleQtyByMonth[m] || 0;
            transformed[yearStr].maxQty[monthKey] = monthlyMax;
            totalMaxSaleQty += monthlyMax; // 총합 누적

            // 현재 월에 해당하는 당월최고수량 만 요약 정보에 추가 20260420
            if (m === currentMonthNow) {
              this.summaryInfo.monthlyMaxGoalQty = monthlyMax;
            }

            // 계약차이 20260724  // 20260806 판매- 계약수량 으로 변경으로 삭제
            // const contractQtyValue = Number(transformed[yearStr].contractQuantity?.[monthKey] || 0);
            // transformed[yearStr].contractDiff[monthKey] = contractQtyValue - monthlyMax;

                // --- 계약달성률(contractRate) 계산 추가 ---
            // const sQty = parseInt(transformed[yearStr].salesQty?.[monthKey]) || 0;
            // if (monthlyMax > 0) {
            //   transformed[yearStr].contractRate[monthKey] = ((sQty / monthlyMax) * 100).toFixed(1) + "%";
            // } else {
            //   transformed[yearStr].contractRate[monthKey] = "";
            // }
          }
          // 계산된 총합을 'totalCnt' 필드에 할당
          transformed[yearStr].maxQty["totalCnt"] = totalMaxSaleQty;
        }
      });
      // --- 끝: 수량 차이 및 최고 수량 계산 ---

      const currentMonth = new Date().getMonth() + 1
      // (salesQty, qtyDiff 등의 totalCnt 계산을 위한 후속 루프가 여기에 와야 함)
      Object.keys(transformed).forEach((yearStr) => {
        [
          "salesQty",
          "qtyDiff",
          "maxQty",
          "averaScore",
          "plannedAmount",
          "appliedRate",
          "actualAmount",
          "amountDiff",
          "salesRevenue",
          "unitPrice",
          "commissionAmt",
          "ownerAmount",
          "netAmount",
          "comPreFeeTotal",
          "comPreFinalDiff",
          "diffAmount",
          "customersIncrease",
          "filterQty",
          "wipersQty",
          "contractQuantity",
          "contractDiff",
          "commissionRate",   // 수수료율 (합계 더해 계산) 20260820 수정
          "netFeeRate",       // 상후수율 (합계 더해 계산) 20260820 수정
          "filterRate",        // 필터비율 (합계 더해 계산) 20260820 수정
          "wipersRate",        // 와이퍼비율 (합계 더해 계산) 20261022 수정
        ].forEach((type) => {
          const row = transformed[yearStr]?.[type];
          if (!row) return;

          let sum = 0;
          let count = 0;

          // 기본 합계/평균 처리
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            let value = row[monthKey];

            if (type === "unitPrice" && value != null && value !== "") {
              count++;
              value = parseFloat(value) || 0;
            } else if (type === "averaScore" && value != null && value !== "") {
              count++;
              value = parseInt(value) || 0;
            } else if (typeof value === "string" && value.includes("%")) {
              value = parseFloat(value.replace("%", "")) || 0;
              if (value !== 0) count++;
            } else {
              value = parseFloat(value) || 0;
            }

            sum += value;
          }

          // --- 특수 계산 항목 ---
          if (type === "commissionRate") {
            // 수수료율 = (수수료합계 ÷ 매출액합계) × 100 (현재달 -1까지만)
            let commissionSum = 0, salesSum = 0;
            for (let m = 1; m < currentMonth; m++) {   // 현재달 -1까지만
              const monthKey = `${m}month`;
              commissionSum += parseFloat(transformed[yearStr]?.commissionAmt?.[monthKey]) || 0;
              salesSum += parseFloat(transformed[yearStr]?.salesRevenue?.[monthKey]) || 0;
            }
            row["totalCnt"] = salesSum > 0 ? ((commissionSum / salesSum) * 100).toFixed(1) + "%" : "";
          } else if (type === "netFeeRate") {
            // 상후수율 = ( (수수료합계 - 업주부담합계) ÷ 매출액합계 ) × 100 (현재달 -1까지만)
            let commissionSum = 0, ownerSum = 0, salesSum = 0;
            for (let m = 1; m < currentMonth; m++) {   // 현재달 -1까지만
              const monthKey = `${m}month`;
              commissionSum += parseFloat(transformed[yearStr]?.commissionAmt?.[monthKey]) || 0;
              ownerSum += parseFloat(transformed[yearStr]?.ownerAmount?.[monthKey]) || 0;
              salesSum += parseFloat(transformed[yearStr]?.salesRevenue?.[monthKey]) || 0;
            }
            row["totalCnt"] = salesSum > 0 ? (((commissionSum - ownerSum) / salesSum) * 100).toFixed(1) + "%" : "";
          } else if (type === "filterRate" || type === "wipersRate") {
            const key = type === "filterRate" ? "filterQty" : "wipersQty";
            const itemSum = parseFloat(transformed[yearStr]?.[key]?.totalCnt) || 0;
            const salesSum = parseFloat(transformed[yearStr]?.salesQty?.totalCnt) || 0;
            row["totalCnt"] = salesSum > 0 ? ((itemSum / salesSum) * 100).toFixed(1) + "%" : "";
          } else if (type === "averaScore" || type === "unitPrice") {
            row["totalCnt"] = count > 0 ? (sum / count).toFixed(1) : "";
          } else {
            row["totalCnt"] = sum;
          }
        });
      });

      // 결과를 배열로 변환
      // 회장님 지시사항 반영 테스트 "-5년 제거"
      // return Object.values(transformed).flatMap((yearData) =>
      //   Object.values(yearData)
      // );
      return Object.keys(transformed)
        .filter((year) => parseInt(year) > currentYear - 3)
        .map((year) => transformed[year])
        .flatMap((yearData) => Object.values(yearData));
    },

    transformQtyData(data) {
      const transformed = {};
      const currentYear = new Date().getFullYear(); // 현재 연도

      // 최고 판매수량 계산
      const maxSaleQtyByMonth = {};

      if (!Array.isArray(data)) {
        console.error("transformData: 입력 데이터가 배열이 아닙니다.", data);
        return [];
      }

      data.forEach((row) => {
        if (!row || !row.SALE_MM) {
          // 문제가 있는 데이터 건너뛰기
          return; // 현재 반복 건너뛰고 다음 row 처리
        }

        const year = parseInt(row.SALE_MM.substring(0, 4)); // 년도 추출
        const month = parseInt(row.SALE_MM.substring(4, 6)); // 월 추출
        const yearYY = year.toString().substring(2, 4); // 연도 YY 추출

        // 월별 최고 판매수량 계산
        if (year <= currentYear - 1) {
          if (
            !maxSaleQtyByMonth[month] ||
            maxSaleQtyByMonth[month] < parseInt(row.SALE_QTY)
          ) {
            maxSaleQtyByMonth[month] = parseInt(row.SALE_QTY);
          }
        }
        if (!transformed[year]) {
          if (year === currentYear) {
            transformed[year] = {
              ownerName: { year: `${year}년`, gubun: "사업주명" },
              manageGuid: { year: `${year}년`, gubun: "컨설턴트" },
              maxQty: { year: `${year}년`, gubun: "최고수량" },
              contractQuantity: { year: `${year}년`, gubun: "계약수량" },
              contractDiff: { year: `${year}년`, gubun: "계약차이" },
              salesQty: { year: `${year}년`, gubun: "판매수량" },
              qtyDiff: { year: `${year}년`, gubun: "최고과부"},
              contractSubtraction: { year: `${year}년`, gubun: "계약과부" },
              contractRate: { year: `${year}년`, gubun: "계약달률" },
              maxRate: { year: `${year}년`, gubun: "최고달률" },    // (최고달률, 계약달률) 추가 20260820 
              averaScore: { year: `${year}년`, gubun: "평균점수" },
              // 회장님 지시사항 반영 20260204 "매출액", "수수료", "수수료율", "보증금액", "재고수량", "이월수량", "이월비율"  추가
              salesRevenue: { year: `${year}년`, gubun: "매출액" },
              unitPrice: { year: `${year}년`, gubun: "판가" },
              targetProfit: { year: `${year}년`, gubun: "목표수익" },   // 목표수익   20260825 추가
            };
          } else {
            transformed[year] = {
              ownerName: { year: `${yearYY}년`, gubun: "사업주명" },
              salesQty: { year: `${yearYY}년`, gubun: "판매수량" },
              qtyDiff: { year: `${yearYY}년`, gubun: "수량차이" },
            };
          }
        }
      
        // 하위 객체 초기화 확인
        if (!transformed[year].salesQty) {
          transformed[year].salesQty = {};
        }
        if (!transformed[year].qtyDiff) {
          transformed[year].qtyDiff = {};
        }

        if (year === currentYear) {
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            if (!transformed[year].contractQuantity[monthKey]) {
              transformed[year].contractQuantity[monthKey] = 0;
            }
            if (!transformed[year].contractDiff[monthKey]) {
              transformed[year].contractDiff[monthKey] = 0;
            }
          }
        }

        // 사업주명 추가
        transformed[year].ownerName[`${month}month`] = row.SHOP_MASTER_NM || "";
        
        // 판매수량 추가
        if (row.SALE_QTY != null ) {
          transformed[year].salesQty[`${month}month`] = Math.round(
            row.SALE_QTY,
          );
        }
        if (year === currentYear) {
          const monthKey = `${month}month`;
          const contractQtyValue = Number(row.CONTRACT_QTY ?? 0);
          if (contractQtyValue > 0 || row.CONTRACT_QTY !== undefined) {
            transformed[year].contractQuantity[monthKey] = contractQtyValue;
          }

          transformed[year].manageGuid[`${month}month`] = row.SHOP_CEO_NM || "";
          if (row.SALE_SCORE_AVG != null && !isNaN(Number(row.SALE_SCORE_AVG))) {
            transformed[year].averaScore[`${month}month`] = Math.round(
              row.SALE_SCORE_AVG,
            );
          }
          transformed[year].salesRevenue[`${month}month`] = row.DCM_SALE_AMT;
          // transformed[year].unitPrice[`${month}month`] = (row.DCM_SALE_AMT/ Math.round(row.SALE_QTY)).toFixed(1);
          transformed[year].unitPrice[`${month}month`] = row.UNIT_PRICE ?? "";
          // 계약달률 (판매수량 ÷ 계약수량 × 100) 20260820 추가
          const salesQtyValue = transformed[year].salesQty?.[`${month}month`] || 0;
          if (salesQtyValue > 0 && contractQtyValue > 0) {
            transformed[year].contractRate[`${month}month`] =
              ((salesQtyValue / contractQtyValue) * 100).toFixed(1) + "%";
          } else {
            transformed[year].contractRate[`${month}month`] = ""; // 판매수량 없거나 계약수량이 0이면 빈값
          }
          // 목표수익 추가 20260825 추가
          transformed[year].targetProfit[`${month}month`] = row.TARGET_PROFIT ?? "";
        }
      });

      // 특정 연도와 월 키에 대한 판매 수량
      const getQty = (transformed, year, monthKey) => {
        // 옵셔널 체이닝을 사용하여 중첩된 속성에 안전하게 접근
        return parseInt(transformed[year]?.salesQty?.[monthKey] || 0);
      };

      // --- 수량 차이(qtyDiff) 및 최고 수량(maxQty) 계산 ---
      Object.keys(transformed).forEach((yearStr) => {
        const numYear = parseInt(yearStr); // 문자열 연도를 숫자로 변환
        const salesQtyRow = transformed[yearStr]?.salesQty; // salesQty 행을 가져옴



        // --- 수량 차이(qtyDiff) 계산 ---
        if (
          salesQtyRow &&
          numYear >= currentYear - 8 &&
          numYear <= currentYear
        ) {

          // salesQtyRow에 있는 월 키들을 순회
          Object.keys(salesQtyRow).forEach((key) => {
            // 실제 월 키('1month', '12month' 등)만 처리
            if (key.endsWith("month")) {
              const currentSaleQty = parseInt(salesQtyRow[key]) || 0; // 현재 월의 판매 수량
              const monthKey = key; // key는 이미 'Nmonth' 형식임

              let maxSaleQty = 0; // 해당 월의 이전 연도들 중 최고 판매 수량
              let diff = 0; // 수량 차이

              // 연도에 따라 특정 차이 계산 로직 적용 (원본 코드와 동일)
              if (numYear <= currentYear) {
                // 현재 연도: 이전 5개년 중 최고값 계산
                maxSaleQty = Math.max(
                  getQty(transformed, currentYear - 8, monthKey),
                  getQty(transformed, currentYear - 7, monthKey),
                  getQty(transformed, currentYear - 6, monthKey),
                  getQty(transformed, currentYear - 5, monthKey),
                  getQty(transformed, currentYear - 4, monthKey),
                  getQty(transformed, currentYear - 3, monthKey),
                  getQty(transformed, currentYear - 2, monthKey),
                  getQty(transformed, currentYear - 1, monthKey),
                );
                // 현재 연도는 diff === 0 케이스 처리가 원본 로직에 없음
                diff = currentSaleQty - maxSaleQty;
                transformed[yearStr].qtyDiff[monthKey] = diff;
              }
              // 참고: currentYear - 4년 이하의 연도에 대해서는 여기서 qtyDiff가 계산되지 않음
              // DB에서 이전에 설정된 'GAP' 값을 유지
            }
          });
        }

        // --- *현재* 연도의 최고 수량(maxQty) 행 계산 ---
        if (numYear === currentYear) {
          // 현재 연도에 maxQty 객체가 존재하는지 확인하고 없으면 생성
          if (!transformed[yearStr].maxQty) {
            transformed[yearStr].maxQty = {
              year: yearStr.substring(2, 4),
              gubun: "최고수량",
            };
          }

          let totalMaxSaleQty = 0; // 월별 최고 수량의 총합을 저장할 변수
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            // 해당 월에 대해 이전 8개년 간의 최고 판매 수량 계산
            const monthlyMax = Math.max(
              getQty(transformed, currentYear - 8, monthKey),
              getQty(transformed, currentYear - 7, monthKey),
              getQty(transformed, currentYear - 6, monthKey),
              getQty(transformed, currentYear - 5, monthKey),
              getQty(transformed, currentYear - 4, monthKey),
              getQty(transformed, currentYear - 3, monthKey),
              getQty(transformed, currentYear - 2, monthKey),
              getQty(transformed, currentYear - 1, monthKey),
            );
            // 계산된 월별 최고 수량을 현재 연도의 maxQty 행에 할당
            transformed[yearStr].maxQty[monthKey] = monthlyMax;
            totalMaxSaleQty += monthlyMax;

            const contractQtyValue = Number(transformed[yearStr].contractQuantity?.[monthKey] || 0);
            transformed[yearStr].contractDiff[monthKey] = contractQtyValue - monthlyMax;
            
            const salesValue = transformed[yearStr].salesQty?.[monthKey];
            // 판매수량 값이 없으면 빈 문자열, 있으면 차이 계산
            if (salesValue == null || salesValue === "") {
              transformed[yearStr].contractSubtraction[monthKey] = "";
            } else {
              transformed[yearStr].contractSubtraction[monthKey] =
                Number(salesValue) - contractQtyValue;
            }
            //최고달률(판매수량 ÷ 최고수량 × 100) 20260820 추가
            if (monthlyMax > 0 && salesValue > 0) {
            transformed[yearStr].maxRate[monthKey] =
              ((salesValue / monthlyMax) * 100).toFixed(1) + "%";
            } else {
              transformed[yearStr].maxRate[monthKey] = ""; // 판매수량 없거나 계약수량이 0이면 빈값
            }
          }
          // 계산된 총합을 'totalCnt' 필드에 할당
          transformed[yearStr].maxQty["totalCnt"] = totalMaxSaleQty;
        }
      });
      // --- 끝: 수량 차이 및 최고 수량 계산 ---

      const currentMonth = new Date().getMonth() + 1;
      // (salesQty, qtyDiff 등의 totalCnt 계산을 위한 후속 루프가 여기에 와야 함)
      Object.keys(transformed).forEach((yearStr) => {
        [
          "salesQty",
          "qtyDiff",
          "maxQty",
          "averaScore",
          "salesRevenue",
          "unitPrice",
          "contractQuantity",
          "contractDiff",
          "contractSubtraction",
          "contractRate",   // 계약달률 (합계 더해 계산) 20260820 수정
          "maxRate",         // 최고달률 (합계 더해 계산) 20260820 수정
          "targetProfit",    // 목표수익 합계 20260825 추가
        ].forEach((type) => {
          const row = transformed[yearStr]?.[type];
          if (!row) return;

          let sum = 0;
          let count = 0;

          // 기본 합계/평균 처리
          for (let m = 1; m <= 12; m++) {
            const monthKey = `${m}month`;
            let value = row[monthKey];

            if (type === "unitPrice" && value != null && value !== "") {
              count++;
              value = parseFloat(value) || 0;
            } else if (type === "averaScore" && value != null && value !== "") {
              count++;
              value = parseInt(value) || 0;
            } else {
              value = parseFloat(value) || 0;
            }
            sum += value;
          }

          // --- 특수 계산 항목 ---
          if (type === "contractRate") {
            // 계약달률 = (판매수량 합계 ÷ 계약수량 합계) × 100
            let salesSum = 0, contractSum = 0;
            for (let m = 1; m <= currentMonth; m++) {
              const monthKey = `${m}month`;
              salesSum += parseFloat(transformed[yearStr]?.salesQty?.[monthKey]) || 0;
              contractSum += parseFloat(transformed[yearStr]?.contractQuantity?.[monthKey]) || 0;
            }
            row["totalCnt"] = contractSum > 0 ? ((salesSum / contractSum) * 100).toFixed(1) + "%" : "";
          } else if (type === "maxRate") {
            // 최고달률 = (판매수량 합계 ÷ 최고수량 합계) × 100
            let salesSum = 0, maxSum = 0;
            for (let m = 1; m <= currentMonth; m++) {
              const monthKey = `${m}month`;
              salesSum += parseFloat(transformed[yearStr]?.salesQty?.[monthKey]) || 0;
              maxSum += parseFloat(transformed[yearStr]?.maxQty?.[monthKey]) || 0;
            }
            row["totalCnt"] = maxSum > 0 ? ((salesSum / maxSum) * 100).toFixed(1) + "%" : "";
          } else if (type === "averaScore" || type === "unitPrice") {
            row["totalCnt"] = count > 0 ? (sum / count).toFixed(1) : "";
          } else {
            row["totalCnt"] = sum;
          }
        });
      });

      // 결과를 배열로 변환 
      return Object.keys(transformed)
        .filter((year) => parseInt(year) >= currentYear - 5)  // -7 -> -5 변경 20260820
        .map((year) => transformed[year])
        .flatMap((yearData) => Object.values(yearData));
    },

    async monthSaleQtyData(shopCd) {
      this.mainTableLoading = true; // 로딩 시작
      this.mainTableData = null; // 이전 데이터 초기화
      this.resetSummaryInfo(); // 요약 정보 초기화

      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1;
      const day = today.getDate();

      // 현재 월의 첫 날 (YYYY-MM-DD 형식)
      const startDate = `${year}${String(month).padStart(2, "0")}01`;
      const thisDate = `${year}${String(month).padStart(2, "0")}${String(
        day,
      ).padStart(2, "0")}`; // 현재 날짜 (YYYY-MM-DD 형식)

      try {
        const response = await axios.get("/api/seListPage/monthSaleQtyData", {
          params: {
            shopCd: shopCd,
            startDate: startDate,
            thisDate: thisDate, // 백엔드에서 thisDate를 사용하므로 전달
          },
        });

        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          this.mainTableData = response.data; // 데이터 저장
          this.processSummaryData(this.mainTableData); // 요약 정보 처리
          this.isExpanded = true;
        } else {
          this.mainTableData = [];
          this.isExpanded = false;
        }
      } catch (error) {
        console.error(
          "Main Table 데이터 가져오기 오류:",
          error.response ? error.response.data : error.message,
        );
        this.mainTableData = [];
        this.isExpanded = false;
      } finally {
        this.mainTableLoading = false;
      }
    },

    // 요약 정보 처리 메소드
    processSummaryData(data) {
      if (!data || data.length === 0) return;

      const firstRecord = data[0];
      const todayString = new Date().toLocaleDateString("sv").replace(/-/g, ""); // 'YYYYMMDD' 형식
      const todayData = data.find((d) => d.YYYYMMDD === todayString);

      // 1. 헤더 값 설정 (첫 번째 레코드 기준)
      // this.summaryInfo.monthlyGoalQty = firstRecord.ZB_GOAL_MM;
      this.summaryInfo.monthlyGoalQty = firstRecord.ZB_GOAL_MM != null 
        ? Number(firstRecord.ZB_GOAL_MM) 
        : null;
      this.summaryInfo.dailyGoalQty = firstRecord.ZB_GOAL_DD;
      this.summaryInfo.monthlyGoalPoints = parseFloat(
        firstRecord.ZA_MNGOAL || 0,
      );

      // 오늘 목표 점수 계산 (VBA 로직 유사하게)
      const monthlyGoalPointsNum = this.summaryInfo.monthlyGoalPoints;
      if (monthlyGoalPointsNum > 0 && this.summaryInfo.lastDayOfMonth > 0) {
        // VBA의 CInt는 반올림과 유사하게 동작할 수 있으므로 Math.round 사용
        this.summaryInfo.dailyGoalPoints = Math.round(
          monthlyGoalPointsNum / this.summaryInfo.lastDayOfMonth,
        );
      } else {
        this.summaryInfo.dailyGoalPoints = 0;
      }

      // 2. 오늘 날짜 기준 값 설정
      if (todayData) {
        this.summaryInfo.personnelTO = todayData.ZB_PERSONNEL || 0;
        this.summaryInfo.personnelActual = todayData.ZB_WORK_CNT || 0;
        this.summaryInfo.todayMatch = todayData.MATCH || 0;
      }

      // 3. 전체 합계 계산
      this.summaryInfo.totalQty = data.reduce(
        (sum, d) => sum + parseInt(d.SALE_QTY || 0),
        0,
      );
      this.summaryInfo.totalPoints = Math.round(
        data.reduce((sum, d) => sum + parseFloat(d.SUM_POINT_DAY || 0), 0),
      );
      this.summaryInfo.totalMatch = data.reduce(
        (sum, d) => sum + parseInt(d.MATCH || 0),
        0,
      );

      // 4. 예상/평균 계산
      const dayOfMonth = this.summaryInfo.currentDayOfMonth;
      const lastDayOfMonth = this.summaryInfo.lastDayOfMonth;

      if (dayOfMonth > 0) {
        this.summaryInfo.projectedQtySum = Math.round(
          (this.summaryInfo.totalQty / dayOfMonth) * lastDayOfMonth,
        );
        this.summaryInfo.projectedPointSum = Math.round(
          (this.summaryInfo.totalPoints / dayOfMonth) * lastDayOfMonth,
        );
        // VBA SUM(D15:J20) / Day(Date) -> 총합 / 오늘날짜(일)
        this.summaryInfo.avgMatch = this.summaryInfo.totalMatch / dayOfMonth;
      } else {
        this.summaryInfo.projectedQtySum = 0;
        this.summaryInfo.projectedPointSum = 0;
        this.summaryInfo.avgMatch = 0;
      }
    },

    // 요약 정보 초기화 메소드
    resetSummaryInfo() {
      this.summaryInfo = {
        monthlyGoalQty: null,
        monthlyMaxGoalQty: null,
        dailyGoalQty: null,
        monthlyGoalPoints: null,
        dailyGoalPoints: null,
        personnelTO: null,
        personnelActual: null,
        todayMatch: null,
        totalQty: 0,
        totalPoints: 0,
        totalMatch: 0,
        projectedQtySum: null,
        projectedPointSum: null,
        avgMatch: null,
        currentDayOfMonth: new Date().getDate(),
        lastDayOfMonth: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0,
        ).getDate(),
      };
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded; // 상태 토글
    },

    // 빈 주차 객체
    createEmptyWeek(weekNum) {
      return {
        week: weekNum,
        sun: null,
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null, // null로 초기화
        qtySum: 0,
        pointSum: 0,
        matchSum: 0,
      };
    },

    commonValueFormatter(params) {
      const value = params.value;

      // 값이 null, undefined 또는 빈 문자열이면 빈 문자열 반환
      if (value === null || value === undefined || value === "") {
        return "";
      }

      // 그 외: 값이 숫자가 아니면(Non-numeric string) 그대로 반환
      if (isNaN(Number(value))) {
        return value;
      }
      // 숫자면 천 단위 콤마 추가하여 반환
      else {
        return Number(value).toLocaleString();
      }
    },

    commonCellStyle(params) {
      if (!params.data) return null; // 데이터 없으면 null

      const gubun = params.data.gubun;
      const value = params.value;
      const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
      const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
      let style = {};
      // 예: 짝수/홀수 행 색상 다르게 
      const rowIndex = params.node.rowIndex;
      //점포운형현황 그리드 스타일
      if (!this.useNewSeListGrid) { 
        if(rowIndex % 2 !== 0 ) {
          style.backgroundColor = "#ffffff" 
        }
        if (gubun == "사업주명"){
            style.textAlign = "center";
          }
        if ( gubun == "수수료"){
          style.backgroundColor =  "#ffff00";
        }
        if ( gubun == "보증금액"){
          style.backgroundColor =  "#ffff00";
        }
        if (gubun ==  "수량차이" || gubun ==  "차액" || gubun ==  "상계차액" || gubun ==  "보증증감" 
          || gubun ==  "증감예측" || gubun ==  "계약차이" || gubun ==  "고용과부") {
          style.color = value < 0 ? "blue" : "red";
        }
        if (gubun ==  "보증예측") {
          style.color = value < 0 ? "blue" : "";
        }
        if(params.colDef.field === 'totalCnt'){
          if(gubun == "최고수량" || gubun == "수량차이"){
            style.backgroundColor = "#ffc080";
            
          }else if(gubun == "판매수량"){
            style.backgroundColor =  "#ffff00";
          }
        }
        if (gubun.includes("계약일") && value) {
          return { backgroundColor: "#ffff00", "text-align": "center" };
        }
      }

      //8년수량 그리드 스타일
      if(this.useNewSeListGrid){
        // if (gubun ==  "수량차이" || gubun ==  "약정차이") {
        if (gubun ==  "최고과부" || gubun ==  "약정차이" || gubun ==  "계약차이" || gubun ==  "계약과부") {
          style.color = value < 0 ? "blue" : "red";
        }
        if(yearPart.length === 2) {
          if (gubun == "사업주명"){
            style.textAlign = "center";
          }
          if(gubun == "판매수량"){
            style.backgroundColor = "#ffffff";
          }
          if(params.colDef.field === 'totalCnt'){
            if(gubun == "판매수량"){
              style.backgroundColor = "#ffff00";
            }
          }
        }else {
          if (gubun == "사업주명"){
            style.textAlign = "center";
          }
          if (gubun == "컨설턴트"){
            style.backgroundColor = "#ffe8e8";
            style.textAlign = "center";
          }
          // if (gubun == "최고수량" || gubun == "매출액"){
          if (gubun == "최고수량" || gubun == "계약차이" || gubun == "평균점수" || gubun == "판가" || gubun == "계약달률"){
            style.backgroundColor = "#ffffff";
          }
          if(gubun == "최고과부"){
            style.backgroundColor = "#ffff00";
          }
          if(params.colDef.field === 'totalCnt'){
            if(gubun == "최고수량" || gubun == "최고과부"){
              style.backgroundColor = "#ffc080";
            }
            if(gubun == "판매수량"){
              style.backgroundColor = "#ffff00";
            }
          }
        }
      }

      return style; // 기본 스타일
    },

    // --- 행 스타일 함수 (기존 getRowStyle 로직 이동) ---
    getRowStyleForGrid2(params) {
      let style = {}; // 기본 스타일 객체

      if (!params.data) {
        return null; // 데이터가 없으면 기본 스타일 반환
      }

      // 1. gubun 존재 시 텍스트 가운데 정렬 추가
      if (params.data.gubun) {
        style["text-align"] = "center"; // 가운데 정렬 스타일 추가
      }

      // 2. 연도(year) 존재 시 배경색 로직 추가
      if (params.data.year) {
        const currentYearLastTwoDigits = new Date()
          .getFullYear()
          .toString()
          .substring(2, 4); // 현재 연도 YY
        const yearLabel = params.data.year.toString(); // 예: "23년" 또는 "2024년"
        let yearLastTwoDigits = "";

        // 연도 라벨 형식에 따라 YY 추출
        if (yearLabel.endsWith("년")) {
          const yearPart = yearLabel.substring(0, yearLabel.length - 1); // "년" 제거
          if (yearPart.length === 4) {
            // "YYYY" 형식
            yearLastTwoDigits = yearPart.substring(2, 4);
          } else if (yearPart.length === 2) {
            // "YY" 형식
            yearLastTwoDigits = yearPart;
          }
        }

        if (yearLastTwoDigits) {
          const yearDiff =
            parseInt(currentYearLastTwoDigits) - parseInt(yearLastTwoDigits);

          // 연도 차이에 따른 배경색 적용
          let backgroundStyle = {};
          if (yearDiff === 7) backgroundStyle = { background: "#97ecff" };
          else if (yearDiff === 6) backgroundStyle = { background: "#b4bfff" };
          else if (yearDiff === 5) backgroundStyle = { background: "#ead6bf" };
          else if (yearDiff === 4) backgroundStyle = { background: "#bef29e" };
          else if (yearDiff === 3) backgroundStyle = { background: "#fff0fd" };
          else if (yearDiff === 2) backgroundStyle = { background: "#dcf3fc" };
          else if (yearDiff === 1) backgroundStyle = { background: "#f1fcb8" };
          else if (yearDiff === 0) backgroundStyle = { background: "#c8fdd1" };

          // 기존 스타일 객체에 배경색 스타일 병합
          style = { ...style, ...backgroundStyle };
        }
      }

      // if (params.data.gubun && 
      // (params.data.gubun.includes("예정약금")|| params.data.gubun.includes("실제약금")|| params.data.gubun.includes("차액"))){
      //   style.background = "#FFF7DD";
      // }
      // if (params.data.gubun && 
      // (params.data.gubun.includes("매출액")|| params.data.gubun.includes("수수료")|| params.data.gubun.includes("수수료율"))){
      //   style.background = "#D9CFC7";
      // }
      // if (params.data.gubun && 
      // (params.data.gubun.includes("보증금액")|| params.data.gubun.includes("재고수량")|| params.data.gubun.includes("이월수량")||
      // params.data.gubun.includes("이월비율"))) {
      //   style.background = "#D9CFC7";
      // }

      // 최종 스타일 객체 반환 (스타일이 적용된 경우) 또는 null 반환 (적용된 스타일이 없는 경우)
      return Object.keys(style).length > 0 ? style : null;
    },

    async fetchShopComments(shopCd) {
      try {
        const response = await axios.get("/api/seListPage/fetchShopComments", {
          params: { shopCd },
        });
        const data = response.data;
        if (data) {
          this.ownerGoal = data.OWNER_GOAL || "";
          this.ownerHow = data.OWNER_HOW || "";
          this.opinion1 = data.OPINION1 || "";
          this.opinion2 = data.OPINION2 || "";
          this.businessMap = data.BUSINESS_MAP || "";
          this.contractConfirm = data.CONTRACT_CONFIRM || "";
        } else {
          this.ownerGoal = "";
          this.ownerHow = "";
          this.opinion1 = "";
          this.opinion2 = "";
          this.businessMap = "";
          this.contractConfirm = "";
        }
      } catch (error) {
        console.error("의견 조회 실패:", error);
      }
    },

    async checkAndSave(fieldName, value, checkField, requiredValue) {
    if (this.userInfo?.[checkField] !== requiredValue) {
      alert("저장 권한이 없습니다.");
      return;
    }
    if(requiredValue !== '00'){
      await this.saveShopGuidance(fieldName, value);
    }else{
      await this.saveShopComments(fieldName, value);
    }
    },

    async saveShopComments(fieldName, value) {
      const shopCd = this.selectedShop?.SHOP_CD ||
      (this.userInfo?.OGN_FG !== '00' ? this.userInfo.SHOP_CD : null);
      
      if (!shopCd) {
        alert("매장을 선택해 주세요.");
        return;
      }
      if (!confirm("저장하시겠습니까?")) return;
      try {
        await axios.post("/api/seListPage/saveShopComments", {
          shopCd: shopCd,
          fieldName: fieldName,
          value: value,
          userId: this.userInfo.userId,
        });
        alert("저장되었습니다.");
      this.fetchShopComments(shopCd);
      } catch (error) {
        console.error("저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    async saveShopGuidance(fieldName, value) {
      const shopCd = this.selectedShop?.SHOP_CD ||
      (this.userInfo?.OGN_FG !== '00' ? this.userInfo.SHOP_CD : null);
      
      if (!shopCd) {
        alert("매장을 선택해 주세요.");
        return;
      }
      if (!confirm("저장하시겠습니까?")) return;
      try {
        await axios.post("/api/seListPage/saveShopGuidance", {
          shopCd: shopCd,
          fieldName: fieldName,
          value: value,
          userId: this.userInfo.userId,
        });
        alert("저장되었습니다.");
      this.fetchShopComments(shopCd);
      } catch (error) {
        console.error("저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    async fetchConfirmations(shopCd){
      try {
        const response = await axios.get("/api/seListPage/fetchConfirmations", {
          params: { shopCd },
        });
        const dbData = response.data;

        // 기존 입력값 초기화
        this.confirmations.forEach((item) => {
          item.signature = "";
          item.signedDt = "";
        });

        // DB에서 가져온 데이터 매핑
        if (dbData && dbData.length > 0) {
          dbData.forEach((dbRow) => {
            const target = this.confirmations.find((c) => c.role === dbRow.CONFIRMER_ROLE);
            if (target) {
              target.signature = dbRow.SIGNATURE || "";
              target.signedDt = dbRow.SIGN_DT || "";
            }
          });
        }
      } catch (error) {
        console.error("확인자 정보 조회 실패:", error);
      }
    },

    async saveConfirmation(item) {
      const shopCd =
        this.selectedShop?.SHOP_CD ||
        (this.userInfo?.OGN_FG !== "00" ? this.userInfo.SHOP_CD : null);

      if (!shopCd) {
        alert("매장이 선택되지 않아 저장할 수 없습니다.");
        return;
      }

      if (!item.signature) {
        alert("서명이 입력되지 않아 저장할 수 없습니다.");
        return;
      }

      if(['재경부1','재경부2','감사팀장'].includes(item.role)){
        // 무조건 오늘 날짜(YYYYMMDD)로 설정
        const today = new Date().toLocaleDateString("sv").replace(/-/g, "");
        item.signedDt = today;
        //this.userInfo?.EMP_NM !== "관리자"
      }else{
        if (!item.signedDt) {
          alert("서명일시가 입력되지 않아 저장할 수 없습니다.");
          return;
        }

        if (item.signedDt.length !== 8 || !/^\d{8}$/.test(item.signedDt)) {
          const today = new Date().toISOString().slice(0,10).replace(/-/g,'');
          alert("서명일시는 YYYYMMDD 형식의 8자리 숫자로 입력해야 합니다.\n예: " + today);
          return;
        }
      }
      // 권한 체크
      if (item.role === "사업주" && this.userInfo?.OGN_FG !== "01") {
        alert("사업주 서명 권한이 없습니다.");
        return;
      }
      if (item.role === "담당감사" && this.userInfo?.EMP_DEPT_NM !== "감사팀") {
        alert("담당감사 서명 권한이 없습니다.");
        return;
      }
      if (item.role === "담당FC" && this.userInfo?.EMP_CLASS_NM !== "본부장") {
        alert("담당FC 서명 권한이 없습니다.");
        return;
      }
      if (item.role === "재경부1" && this.userInfo?.EMP_DEPT_NM !== "재경부") {
        alert("재경부1 서명 권한이 없습니다.");
        return;
      }
      if (item.role === "재경부2" && this.userInfo?.EMP_CLASS_NM !== "재경부") {
        alert("재경부2 서명 권한이 없습니다.");
        return;
      }
      if (item.role === "감사팀장" && this.userInfo?.EMP_NM !== "육상용") {
        alert("감사팀장 서명 권한이 없습니다.");
        return;
      }

      try {
        const payload = {
          shopCd: shopCd,
          role: item.role,
          signature: item.signature,
          signedDt: item.signedDt,
          seqNo: item.seqNo,
          userId: this.userInfo.userId,
        };

        const response = await axios.post("/api/seListPage/saveConfirmation", payload);

        if (response.data.success) {
          alert(response.data.message);
        }
        this.fetchConfirmations(shopCd);
      } catch (error) {
        console.error("확인자 정보 저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다.");
      }
    },

    openAnalysisPopup() {
      this.showAnalysisPopup = true;
    },
    closeAnalysisPopup() {
      this.showAnalysisPopup = false;
    },

    leftGridCopy() {
      this.copyData(this.leftGridApi);
    },

    copyData(gridApi) {
      if (!gridApi) {
        alert("그리드 복사 기능을 사용할 수 없습니다. 데이터를 다시 불러온 후 다시 시도해주세요.");
        return;
      }
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },
  },
  watch: {
    auditKind(newKind) {
      if (newKind !== "감사") {
        this.auditScore = "";
      }
    },
    useNewSeListGrid(newVal) {
      // Prop 변경 시 높이 재계산 및 적용
      this.handleResize();

      const shopCd = 
      this.selectedShop ? this.selectedShop.SHOP_CD : (this.userInfo && this.userInfo.OGN_FG !== "00" ? this.userInfo.SHOP_CD : null);
      
      if (shopCd) {
        if (newVal) {
          this.detailsQty(shopCd);
        } else {
          this.details(shopCd);
        }
      } else{
        if (newVal) {
          alert("매장을 선택 후 클릭 하세요.");
          this.$emit("reset-grid-view");
        }
      }
    },
  },
  computed: {
    lastProfitTotal() {
      if (!this.rowData1 || this.rowData1.length === 0) {
        return 0;
      }
      // rowData1 배열의 각 항목에서 LASTPROFIT 값을 숫자로 변환하여 합산
      return this.rowData1.reduce((sum, row) => {
        const lastProfit = Number(row.LASTPROFIT) || 0; // 숫자로 변환, NaN이면 0
        const profit = Number(row.PROFIT) || 0; // 숫자로 변환, NaN이면 0
        const difference = lastProfit + profit;
        return sum + difference; // 각 행의 차이를 합산
      }, 0);
    },

    // 하단 고정 행 데이터 생성
    pinnedBottomRow() {
      // 합계 행 객체 생성
      const summaryRow = {
        // 다른 컬럼에 '합계' 같은 텍스트를 표시
        VAN_BIZ_NO: "합계",
        SHOP_NM: null,
        PROFIT: null,
        LASTPROFIT: this.lastProfitTotal,
        // "사업 보증금 합계" 컬럼에 계산된 총합 표시
        TOTALPROFITSUM: null,
        TRBIZ_TYPE: null,
      };
      // AG Grid는 배열 형태를 기대하므로 배열로 감싸서 반환
      return [summaryRow];
    },

    analysisResults() {
      // 선택된 행이 있으면 해당 데이터를, 없으면 전체 rowData1을 사용
      const dataToAnalyze = this.selectedRowData || this.rowData1;

      // --- 기존 변수 초기화 ---
      let lMonthMin = 0,
        lMonthMinStoreCount = 0,
        lMonthPlus = 0,
        lMonthPlusStoreCount = 0;
      let lTotalMin = 0,
        lTotalMinStoreCount = 0,
        lTotalPlus = 0,
        lTotalPlusStoreCount = 0;
      let lMPSum = 0,
        lMPCnt = 0,
        lMMSum = 0,
        lMMCnt = 0;
      let lPPSum = 0,
        lPPCnt = 0,
        lPMSum = 0,
        lPMCnt = 0;
      const totalStoreCount = dataToAnalyze.length;

      // --- 데이터 없을 경우 기본값 반환 ---
      if (!dataToAnalyze || totalStoreCount === 0) {
        const defaultGroup = {
          currentPositiveSum: 0,
          currentPositiveCount: 0,
          currentPositiveRatio: 0,
          currentNegativeSum: 0,
          currentNegativeCount: 0,
          currentNegativeRatio: 0,
        };
        return {
          lastMonth: {
            sum: 0,
            count: 0,
            ratio: 0,
            negSum: 0,
            negCount: 0,
            negRatio: 0,
          },
          currentMonth: {
            sum: 0,
            count: 0,
            ratio: 0,
            negSum: 0,
            negCount: 0,
            negRatio: 0,
          },
          analysis2: { lastPositive: defaultGroup, lastNegative: defaultGroup },
          totalStoreCount: 0,
        };
      }

      // --- 데이터 순회 및 합계 계산 (기존 로직 유지) ---
      dataToAnalyze.forEach((row) => {
        const profit = Number(row.PROFIT) || 0;
        const lastProfit = Number(row.LASTPROFIT) || 0;

        // 당월 수익 기준
        if (profit <= 0) {
          lMonthMin += profit;
          lMonthMinStoreCount++;
        } else {
          lMonthPlus += profit;
          lMonthPlusStoreCount++;
        }

        // 전월 실선미 기준
        if (lastProfit <= 0) {
          // 전월 적자 그룹
          lTotalMin += lastProfit;
          lTotalMinStoreCount++;
          if (profit > 0) {
            lMPSum += profit;
            lMPCnt++;
          } else {
            lMMSum += profit;
            lMMCnt++;
          }
        } else {
          // 전월 흑자 그룹
          lTotalPlus += lastProfit;
          lTotalPlusStoreCount++;
          if (profit > 0) {
            lPPSum += profit;
            lPPCnt++;
          } else {
            lPMSum += profit;
            lPMCnt++;
          }
        }
      });

      // --- 비율 계산 함수 ---
      const safeRatio = (count, total) =>
        total === 0 ? 0 : (count / total) * 100;

      // --- 그룹 내 비율 계산 ---
      const lastPositiveTotalCount = lPPCnt + lPMCnt; // 전월 흑자 그룹 총 점포수
      const lastNegativeTotalCount = lMPCnt + lMMCnt; // 전월 적자 그룹 총 점포수

      // --- 최종 결과 객체 반환 ---
      return {
        totalStoreCount: totalStoreCount,
        // 사업주분석1 테이블용 데이터
        lastMonth: {
          sum: lTotalPlus,
          count: lTotalPlusStoreCount,
          ratio: safeRatio(lTotalPlusStoreCount, totalStoreCount),
          negSum: lTotalMin,
          negCount: lTotalMinStoreCount,
          negRatio: safeRatio(lTotalMinStoreCount, totalStoreCount),
        },
        currentMonth: {
          sum: lMonthPlus,
          count: lMonthPlusStoreCount,
          ratio: safeRatio(lMonthPlusStoreCount, totalStoreCount),
          negSum: lMonthMin,
          negCount: lMonthMinStoreCount,
          negRatio: safeRatio(lMonthMinStoreCount, totalStoreCount),
        },
        // 사업주분석2 테이블용 데이터
        analysis2: {
          lastPositive: {
            // 전월 흑자 그룹
            currentPositiveSum: lPPSum, // 당월 흑자 합계
            currentPositiveCount: lPPCnt, // 당월 흑자 점포수
            currentPositiveRatio: safeRatio(lPPCnt, lastPositiveTotalCount), // 그룹 내 당월 흑자 비율
            currentNegativeSum: lPMSum, // 당월 적자 합계
            currentNegativeCount: lPMCnt, // 당월 적자 점포수
            currentNegativeRatio: safeRatio(lPMCnt, lastPositiveTotalCount), // 그룹 내 당월 적자 비율
          },
          lastNegative: {
            // 전월 적자 그룹
            currentPositiveSum: lMPSum, // 당월 흑자 합계
            currentPositiveCount: lMPCnt, // 당월 흑자 점포수
            currentPositiveRatio: safeRatio(lMPCnt, lastNegativeTotalCount), // 그룹 내 당월 흑자 비율
            currentNegativeSum: lMMSum, // 당월 적자 합계
            currentNegativeCount: lMMCnt, // 당월 적자 점포수
            currentNegativeRatio: safeRatio(lMMCnt, lastNegativeTotalCount), // 그룹 내 당월 적자 비율
          },
        },
      };
    },

    weeklySalesData() {
      if (!this.mainTableData || this.mainTableData.length === 0) {
        return { qtyWeeks: [], pointWeeks: [], matchWeeks: [] }; // matchWeeks 추가
      }

      const sortedData = [...this.mainTableData].sort((a, b) =>
        a.YYYYMMDD.localeCompare(b.YYYYMMDD),
      );

      const qtyWeeks = [];
      const pointWeeks = [];
      const matchWeeks = []; // 적합도 주차 배열 추가
      let currentWeekNum = 1;
      let currentQtyWeek = this.createEmptyWeek(currentWeekNum);
      let currentPointWeek = this.createEmptyWeek(currentWeekNum);
      let currentMatchWeek = this.createEmptyWeek(currentWeekNum); // 적합도 객체 초기화
      let weekHasData = false;

      const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

      // 해당 월의 첫 날 요일 계산 (0: 일요일, 6: 토요일)
      const firstDayOfMonth = new Date(
        parseInt(sortedData[0].YYYYMMDD.substring(0, 4)),
        parseInt(sortedData[0].YYYYMMDD.substring(4, 6)) - 1,
        1,
      ).getDay();

      sortedData.forEach((dayData) => {
        const dayOfMonth = parseInt(dayData.YYYYMMDD.substring(6, 8));
        const dayOfWeekIndex = parseInt(dayData.D) - 1; // 0: 일요일, 6: 토요일
        const dayKey = dayMap[dayOfWeekIndex];
        // const dateString = dayData.YYYYMMDD; // 현재 데이터의 날짜 (YYYYMMDD)

        const weekOfMonth =
          Math.floor((dayOfMonth - 1 + firstDayOfMonth) / 7) + 1;

        // 계산된 주차(weekOfMonth)가 현재 주차(currentWeekNum)와 다르면 새 주 시작
        if (weekOfMonth > currentWeekNum && weekHasData) {
          // 이전 주 합계 포맷팅
          currentPointWeek.pointSum = Math.round(
            currentPointWeek.pointSum,
          ).toLocaleString();
          // 이전 주 데이터 저장
          qtyWeeks.push(currentQtyWeek);
          pointWeeks.push(currentPointWeek);
          matchWeeks.push(currentMatchWeek); // 적합도 주 저장

          currentWeekNum = weekOfMonth; // 다음 주로 업데이트
          currentQtyWeek = this.createEmptyWeek(currentWeekNum);
          currentPointWeek = this.createEmptyWeek(currentWeekNum);
          currentMatchWeek = this.createEmptyWeek(currentWeekNum); // 새 적합도 객체
          weekHasData = false;
        }
        // 첫 데이터 처리 시 currentWeekNum 설정
        if (!weekHasData) {
          currentWeekNum = weekOfMonth;
          currentQtyWeek.week = currentWeekNum;
          currentPointWeek.week = currentWeekNum;
          currentMatchWeek.week = currentWeekNum;
        }

        // 데이터 할당
        const saleQty = parseInt(dayData.SALE_QTY || 0);
        const sumPointDay = parseFloat(dayData.SUM_POINT_DAY || 0);
        const matchValue = parseInt(dayData.MATCH || 0);

        currentQtyWeek[dayKey] = saleQty;
        currentPointWeek[dayKey] = Math.round(sumPointDay).toLocaleString();
        currentMatchWeek[dayKey] = matchValue; // 적합도 값 할당

        // 주간 합계 누적
        currentQtyWeek.qtySum += saleQty;
        currentPointWeek.pointSum += sumPointDay; // 합계는 반올림/포맷팅 전 값으로 누적
        currentMatchWeek.matchSum += matchValue; // 오늘까지의 값만 합산

        weekHasData = true;
      });

      // 마지막 주 데이터 추가
      if (weekHasData) {
        qtyWeeks.push(currentQtyWeek);
        pointWeeks.push(currentPointWeek);
        matchWeeks.push(currentMatchWeek);
      }

      // 6주까지 강제로 채우기
      while (qtyWeeks.length < 6) {
        const weekNum = qtyWeeks.length + 1;
        qtyWeeks.push(this.createEmptyWeek(weekNum));
        pointWeeks.push(this.createEmptyWeek(weekNum));
        matchWeeks.push(this.createEmptyWeek(weekNum));
      }

      return { qtyWeeks, pointWeeks, matchWeeks }; // matchWeeks 포함하여 반환
    },
  },
};
</script>

<style scoped>
body {
  font-size: 0.9rem; /* 기본 폰트 크기 */
  font-family: "Malgun Gothic", Arial, sans-serif;
}

.left-section-top {
  display: flex; /* 가로 정렬 */
  align-items: center; /* 수직 중앙 정렬 */
  gap: 1px; /* 요소 간 간격 */
}

.header-table {
  width: 55%; /* 테이블 너비를 50%로 설정 */
  border-collapse: collapse;
  table-layout: fixed; /* 셀 크기를 균일하게 유지 */
  background-color: yellow;
}

.header-table th,
.header-table td {
  border: 1px solid black; /* 테두리 추가 */
  border-collapse: collapse;
  text-align: center;
  padding: 5px;
}

.avaiCus {
  color: red;
}

.right-section-top {
  display: flex;
  flex-direction: row;
  margin-bottom: 2px;
  margin-top: 2px;
}

.buttons-container {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 3;
  align-items: flex-start;
}

.buttons-container button {
  display: flex;
  align-items: center; /* 수직 중앙 정렬 */
  justify-content: center; /* 수평 중앙 정렬 */
  font-size: 0.9rem;
  height: 22px;
  margin-left: 0.5rem;
  border-radius: 5px;
}

.right-info-container {
  display: flex;
  flex: 7;
  flex-direction: row;
  gap: 1px;
  justify-content: center;
}

.right-info-label {
  font-size: 1.25rem;
  /* font-weight: bold; */
  margin-bottom: 2px;
  background-color: #ffc080;
  border: 1px solid #ccc;
  text-align: center;
}

.right-info-left,
.right-info-right {
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  border-radius: 5px;
  box-sizing: border-box;
}

/* 전체 레이아웃 */
.se-list-page {
  display: flex;
  flex-direction: row; /* 가로 배치 */
  padding: 2px;
  font-family: "Malgun Gothic", Arial, sans-serif;
}

/* 왼쪽 섹션 */
.left-section {
  display: flex;
  flex-direction: column;
  width: 70%;
}

/* 펼쳐진 상태: .left-section에 expanded 클래스가 있을 때 */
.left-section.expanded .expandable-content {
  /* grid 높이(25rem) + table 높이 + 여백 고려 */
  max-height: 100vh;
  overflow-y: auto; /* 필요시 auto로 변경하여 스크롤바 생성 */
}

/* 새로운 래퍼: 펼치기/접기 대상 */
.expandable-content {
  overflow: hidden; /* 내용 숨김 (접힌 상태) */
  max-height: 0; /* 접힌 상태에서는 높이 0 */
  /* transition: max-height 0.1s ease-out; 부드러운 전환 효과 (시간 조절 가능) */
}

/* 메인 테이블 컨테이너 - 기본 (접힌) 상태 */
.main-table-container {
  overflow-y: visible; /* 내용 보이도록 */
}

/* 펼쳐진 상태: .left-section에 expanded 클래스가 있을 때 */
.left-section.expanded .main-table-container {
  max-height: 12rem;
  overflow-y: auto;
  /* transition: max-height 0.1s ease-out; 부드러운 전환 효과 */
}

/* 오른쪽 섹션 */
.right-section {
  display: flex;
  flex-direction: column;
  width: 30%;
}

/* 분석 테이블 스타일 */
.analysis-table {
  table-layout: fixed; /* 셀 크기를 균일하게 유지 */
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}

.analysis-table th,
.analysis-table td {
  border: 1px solid black;
  text-align: center;
  padding: 5px;
}

/* .analysis-table th {
  background-color: #f0f0f0;
} */

.analysis-table td {
  background-color: #ffffff;
  text-align: right;
  font-weight: bold;
}

/* 요약 정보 테이블 스타일 추가 */
.summary-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-bottom: 10px; /* 메인 테이블과의 간격 */
  background-color: #f8f8f8; /* 약간 다른 배경색 */
}

.summary-table th,
.summary-table td {
  border: 1px solid #ccc;
  text-align: center;
  padding: 4px;
}

.summary-table th {
  background-color: #e0e0e0;
  font-weight: bold;
  width: 10%; /* 헤더 너비 고정 시도 */
}
.summary-table td {
  width: 10%; /* 데이터 셀 너비 고정 시도 */
}

/* 메인 테이블 스타일 */
.main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.6rem;
}

.main-table thead tr th:nth-child(2) {
  /* thead 안의 tr의 두 번째 th ("항목") */
  width: 10%; /* 원하는 너비 값으로 조절하세요 (예: 80px) */
}

.main-table tbody tr td:nth-child(2)[rowspan] {
  writing-mode: vertical-rl;
  text-orientation: upright;
  vertical-align: middle;
  text-align: center;
}

.main-table .score-row td {
  background-color: #f7f7ce;
  text-align: center;
  padding: 4px;
  font-weight: bold;
}

.main-table .score-row td:nth-last-child(-n + 7) {
  color: #0000ff; /* 원하는 새로운 배경색으로 변경 (예: 연한 녹색) */
  /* 다른 스타일은 기본 .score-row td 스타일을 상속 */
}

.main-table tbody > tr.score-row:last-of-type td[colspan="2"]:nth-of-type(1),
.main-table tbody > tr.score-row:last-of-type td[colspan="2"]:nth-of-type(3) {
  color: black; /* .score-row 기본 배경색 */
}

/* --- 인원적합도 행 스타일 --- */
.main-table .match-row td {
  background-color: #e9cec9;
  text-align: center;
  padding: 4px;
  font-weight: bold;
}

.main-table .match-row td:nth-last-child(-n + 7) {
  color: #ff0000; /* 원하는 새로운 배경색으로 변경 */
  /* 다른 스타일은 기본 .score-row td 스타일을 상속 */
}

/* 인원적합도 요약 행: 평균 라벨 셀 배경색 (기본 match-row 색상으로 복원) */
.main-table tbody > tr.match-row:last-of-type td[colspan="2"]:nth-of-type(1) {
  color: black; /* .match-row 기본 배경색 */
}

.main-table th,
.main-table td {
  border: 1px solid black;
  text-align: center;
  padding: 3px;
}

.main-table th {
  background-color: #a0caf3;
  font-weight: bold;
}

.main-table td {
  background-color: #ffffff;
  font-weight: bold;
  height: 5px;
}

.side-table{
  width: 100%;
  border-collapse: collapse;
  font-size: 0.7rem;
}

:deep(.ag-se-balham) {
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

/* grid 헤더 스타일 */
:deep(.ag-se-balham .ag-header-cell-text) {
  color: #333; /* 텍스트 색상 */
  font-size: 0.725rem;
}
/* grid 헤더 스타일 */
:deep(.ag-se-balham .ag-header-cell) {
  background-color: #f7f7f7; /* 밝은 배경색 */
}

/* grid 헤더 텍스트 정렬 */
:deep(.ag-se-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  text-align: center;
}

/* grid 데이터 셀 스타일 */
:deep(.ag-se-balham .ag-cell) {
  font-size: 0.8rem;
  text-align: right;
  /* padding-right: 3px; */
}
/* grid 헤더 배경색 */
:deep(.ag-se-balham .ag-header-container) {
  /* 헤더 배경색 */
  background-color: #f0f0f0 !important;
}

:deep(.right-grid .ag-row-hover) {
  background-color: #d7d8db; /* 적절히 어두운 배경색 */
  border: 1px solid #ffffff; /* 밝은 테두리 */
}

:deep(.right-grid .ag-row-selected),
:deep(.right-grid .ag-row-selected .ag-cell) {
  background-color: #ffff00 !important;
}

:deep(.ag-se-balham .ag-cell.ag-column-first.year-cell) {
  font-weight: bold;
  font-size: 0.9rem;
  writing-mode: vertical-rl; /* 세로 쓰기 모드 */
  text-orientation: upright; /* 세로 텍스트 방향 */
  padding-right: 5px;
  width: 20px;
  border-bottom: 1px solid #c0c0c0;
}

/* 합계 행 스타일 */
:deep(.ag-se-balham .ag-floating-bottom) {
  overflow: hidden !important;
  pointer-events: none;
  background-color: #ffc8ff; /*합계 행 배경색 */
}

:deep(.ag-se-balham .ag-floating-bottom-container .ag-cell) {
  font-weight: bold; /* 합계 행 텍스트 굵게 (선택 사항) */
  /* 필요하다면 배경색 등 추가 스타일 지정 */
  background-color: #ffc8ff;
}

/*  셀 숨기기(여기서는 PROFIT 컬럼) */
:deep(.ag-se-balham .ag-floating-bottom-container .ag-cell[col-id="PROFIT"]),
:deep(.ag-se-balham .ag-floating-bottom-container .ag-cell[col-id="rowIndex"]),
:deep(
    .ag-se-balham .ag-floating-bottom-container .ag-cell[col-id="LASTPROFIT"]
  ) {
  border-left: none; /* 왼쪽 테두리 제거 */
  border-right: none; /*마지막 셀이라면 오른쪽 테두리는 유지하거나 필요에 따라 조정*/
  display: none; /* 셀 숨기기 */
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-se-balham .ag-cell) {
    font-size: 1rem;
  }
  :deep(.ag-se-balham .ag-header-cell-text) {
    font-size: 0.85rem;
  }
  .confirmation-table th, .confirmation-table td {
  font-size: 0.8rem;
  }
  .main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
  }
  .side-table{
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
  }
}

.expanded-table {
  width: 70%;
}

.toggle-button-container {
  /* padding-top: 1px;  테이블과의 간격  */
  /* box-sizing: border-box; 패딩 포함하여 너비 계산  */
  display: none;
}

.toggle-button {
  font-size: 0.4rem;
  cursor: pointer;
  color: white;
  border: none;
  border-radius: 5px;
  width: 100%; 
  box-sizing: border-box;
  padding: 1px; 
}

.toggle-button:hover {
  background-color: #0056b3;
}

/* 성공목적 및 의견 입력 스타일 */
.shop-comment-section {
  padding: 1px 1px 1px 0;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-top: none;
}

.comment-row {
  padding: 2px 2px 2px 0;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1px;
}

.comment-index {
  width: 20px;
  min-height: 26px; /* label 높이와 맞춤 */
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-right: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.comment-row label {
  width: 130px;
  font-size: 0.85rem;
  font-weight: bold;
  color: #444;
  background-color: #ececec;
  padding: 4px;
  border: 1px solid #ccc;
  text-align: center;
  margin-right: 5px;
  white-space: nowrap;
}

.comment-row:nth-of-type(4) .comment-index {
  height: 56px; 
}

.comment-row:nth-of-type(4) label {
  height: 48px; 
  display: flex; 
  align-items: center;   
  justify-content: center; 
}

.comment-row input,
.comment-row textarea {
  flex: 1;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 2px;
  font-size: 0.9rem;
}

textarea {
  resize: none;
}

.btn-save-comments {
 margin-left: 2px;
  padding: 4px 10px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border: 1px solid #357abd;
  border-radius: 2px;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.85rem;
  white-space: nowrap;
}

.btn-save-comments:hover {
  background-color: #357abd;
}

/* 확인자 테이블 */
.confirmation-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.6rem;
}

.confirmation-table th, .confirmation-table td {  
  border: 1px solid black;
  text-align: center;
  padding: 3px;
  font-weight: bold;
  background-color: #ffffff;
}

.confirmation-table th {
  background-color: #d0d0d0;
}

.confirmer-select, .confirmation-input {
  width: 90%;
  border: none;
  text-align: center;
  font-family: "Malgun Gothic", Arial, sans-serif;
  color: #000;              /* 글자색도 동일하게 */
}

.confirmation-save-cell {
  padding: 6px 0; /* 셀 자체 여백 */
}

.confirmation-save-btn {
  background-color: #4a90e2;
  color: white;
  padding: 1px 2px;
  border-radius: 4px;
  font-weight: bold;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  transition: 0.2s;
}

.confirmation-save-btn:hover {
  background-color: #3a78c5;
}


/* 우클릭 감사/점정보 패널 스타일 */
.audit-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
/* 변경: 가로폭은 화면에 맞게, 세로는 화면의 80% 이내로 */
.audit-modal {
  width: 70%;
  max-width: 900px; /* 필요시 조정 */
  max-height: 80vh; /* 화면 높이의 80% 이내 */
  background: white;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* 헤더 고정 */
.audit-header {
  display: flex;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
  flex: 0 0 auto;
}
.audit-title {
  font-weight: 700;
}
.audit-close {
  background: #eee;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
}

/* 본문은 스크롤 가능 영역으로 변경 */
.audit-body {
  padding: 10px;
  overflow: auto;
  flex: 1 1 auto; /* 남은 높이를 차지하여 내부 스크롤 발생 */
  box-sizing: border-box;
  min-height: 120px;
}

/* store-info, controls 레이아웃 정리 */
.store-info {
  margin-bottom: 8px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}
.audit-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

/* 테이블 가로폭 100%로 변경, 고정 폭 제거 */
.audit-grid {
  max-height: calc(80vh - 220px);
  overflow: auto;
} /* 패널 높이에 맞춰 내부 테이블 스크롤 처리 */
.audit-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  table-layout: fixed; /* 컬럼 고정 분배: 가로 스크롤 방지 */
  box-sizing: border-box;
}
.audit-table th,
.audit-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
  word-break: break-word; /* 긴 텍스트 줄바꿈 */
}

/* 입력 요소가 셀 너비에 맞도록 */
.audit-table input[type="text"],
.audit-table input[type="date"],
.audit-table select {
  width: 100%;
  box-sizing: border-box;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 2px;
  font-size: 0.9rem;
}

/* 삭제 버튼 최소 너비 지정 */
.audit-table button {
  min-width: 48px;
  height: 28px;
  padding: 4px;
  box-sizing: border-box;
}

/* footer 고정 */
.audit-footer {
  padding: 8px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  background: #fafafa;
  border-top: 1px solid #eee;
  flex: 0 0 auto;
}

/* 반응형: 좁은 화면에서 폰트/패딩 조정 */
@media (max-width: 600px) {
  .audit-modal {
    max-width: 98%;
  }
  .audit-table th,
  .audit-table td {
    padding: 4px;
    font-size: 0.85rem;
  }
  .audit-table button {
    min-width: 40px;
    height: 26px;
  }
}

/* 우클릭 감사/점정보 패널 스타일 */
.analysis-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
/* 변경: 가로폭은 화면에 맞게, 세로는 화면의 80% 이내로 */
.analysis-modal {
  width: 60%;
  max-width: 800px; /* 필요시 조정 */
  max-height: 70vh; /* 화면 높이의 80% 이내 */
  background: white;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/* 헤더 고정 */
.analysis-modal-header {
  display: flex;
  justify-content: space-between;
  padding: 2px 14px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
  flex: 0 0 auto;
}

.analysis-modal-close-btn{
  background-color: #faf60f;
  font-size: 1rem;
  color: #ff2700;
  cursor: pointer;
}
/* 깜빡임 표현 */
.blink {
  animation: blink-effect-red 2s step-end infinite;
  animation-delay: 0s;
}

@keyframes blink-effect-red {
  0%,
  100% {
    background-color: #ffff00; /* 빨간색 */
  }
  50% {
    background-color: #ffffff; /* 하얀색 */
  }
}
</style>
